<template>
    <!-- <div class="preloader">
      <div class="preloader-body">
        <div class="cssload-container">
          <div class="cssload-speeding-wheel"></div>
        </div>
        <p>Loading...</p>
      </div>
    </div> -->
    <!-- Page-->
    <div class="page text-center">
      <!-- Swiper-->
      <section class="swiper-slide-wrapper">
        <!-- <div class="swiper-container swiper-slider" data-simulate-touch="false" data-autoplay="3500" data-slide-effect="fade">
          <div class="swiper-wrapper">
            <div class="swiper-slide" data-slide-bg="../assets/images/background-06.jpg"></div>
            <div class="swiper-slide" data-slide-bg="../assets/images/background-08.jpg"></div>
          </div>
        </div> -->
        <div class="swiper-onSlider">
          <div class="container container-wide section-70 section-xxl-top-200 section-xxl-bottom-220">
            <div class="row justify-content-sm-center">
              <div class="col-lg-9">
                <div class="responsive-tabs text-lg-left nav-custom-dark view-animate fadeInUpSmall" data-type="horizontal">
                  <!-- Responsive-tabs-->
                  <ul class="nav-custom-tabs resp-tabs-list">
                    <li class="nav-item" :class="{ active: activeTab === 'flights' }" @click="setActiveTab('flights')"><span class="icon mdi mdi-airplane"></span><span>Flights</span></li>
                    <li v-if="this.RecentSearchData.length > 0" class="nav-item" :class="{ active: activeTab === 'recentSearches' }" @click="setActiveTab('recentSearches')"><span class="icon mdi mdi-history"></span><span>Recent Searches</span></li>
                    <!-- <li class="nav-item"><span class="icon mdi mdi-hotel"></span><span>Hotels</span></li>
                    <li class="nav-item"><span class="icon mdi mdi-car"></span><span>Car Hire</span></li> -->
                  </ul>
                  <div v-if="activeTab == 'flights'" class="resp-tabs-container nav-custom-tab nav-custom-wide">
                    <div>
                      <v-form class="small">
                        <div class="row text-start d-flex justify-content-between align-center">
                          <div class="col-lg-6 mb-0 ps-5">
                            <div class="form-wrap radio-inline-wrapper">
                              <v-radio-group v-model="radios" inline>
                                <v-radio label="RoundTrip" value="round" @click="act(1)"></v-radio>
                                <v-radio label="Oneway" value="oneway" @click="act(2)"></v-radio>
                                <v-radio label="Multicity" value="multicity" @click="act(3)"></v-radio>
                              <!-- <label class="d-md-none d-block checkbox-inline d-flex justify-end align-center">
                                <input name="input-group-radio" v-model="directflight" value="checkbox-1" type="checkbox" class="me-1">Direct Flights Only
                              </label> -->
                              <v-checkbox class="d-md-none d-block" v-model="directflight" label="Direct Flights Only" @change="directflight = $event ? true : false"></v-checkbox>
                              </v-radio-group>
                            </div>
                          </div>
                          <div class="d-lg-flex d-md-flex justify-md-end d-none col-lg-4 text-lg-right mb-0 pe-5">
                            <div class="form-wrap directFlight">
                              <!-- <label class="checkbox-inline d-flex justify-end align-center">
                                <input name="input-group-radio" v-model="directflight1" value="checkbox-1" type="checkbox" class="me-1">Direct Flights Only
                              </label> -->
                              <v-checkbox v-model="directflight" label="Direct Flights Only" @click="directflight = directflight ? true : false"></v-checkbox>
                            </div>
                          </div>
                          <div v-if="multicity" class="col-lg-8 text-lg-right mb-0">
                            <div class="row">
                              <div class="col-lg-5">
                                      <div class="form-grp">
                                      <div class="labelTop">
                                          <p class="m-0 text-start">Cabin Class</p>
                                        </div>
                                      <v-select v-model="classType"
                                        :items="classTypeitems" ref="mySelect"
                                        class="select-2"
                                        item-title="value" style="color: black">
                                        <template v-slot:item="{ props, item, index }">
                                          <v-list-item v-bind="props"
                                            :subtitle="item.department" @click="selectClasstype(item, index)">
                                          </v-list-item>
                                        </template>
                                      </v-select>
                                      </div>
                                    </div>
                                    <div class="col-lg-5">
                                        <div class="labelTop">
                                          <p class="m-0 text-start"> Passenger</p>
                                        </div>
                            <div class="form-wrap">
                              <div class="input-styles-2 select-option rounded-border">
                                    <v-select
                                      v-model="selectedCountry"
                                      :items="countries"
                                      ref="countrySelect"
                                      style="position: relative; top: 0px"
                                      class="select-1"
                                    >
                                      <!-- <template #item="{ item }"> -->
                                      <template #item="{}">
                                        <div class="dropdown_section" style="cursor: pointer">
                                          <div
                                            class="row d-flex align-center my-2 mx-1"
                                            @click.stop>
                                            <div
                                              class="col-3"
                                              style="width: 38%"
                                            >
                                              <span
                                                style="
                                                  font-size: 14px;
                                                  font-weight: 500;
                                                  color: #4e4d4d;
                                                "
                                                >Adult</span
                                              >
                                            </div>
                                            <div
                                              class="col-3 px-0"
                                              style="width: 9%"
                                            >
                                              <v-icon
                                                style="
                                                  width: auto;
                                                  color: grey;
                                                  font-size: 18px;
                                                "
                                              >
                                                mdi-human-male-female
                                              </v-icon>
                                            </div>
                                            <div
                                              class="col-6 adult"
                                              style="width: 50%; height: auto"
                                            >
                                              <div
                                                class="row"
                                                style="padding: 0px"
                                              >
                                                <div
                                                  class="col-4 formbuttons text-center"
                                                  @click="deg1()"
                                                  style="
                                                    background-color: #c62a82;
                                                    color: white;
                                                  "
                                                >
                                                  <div class="adult-plus">
                                                    -
                                                  </div>
                                                </div>
                                                <div
                                                  class="col-4"
                                                  style="
                                                    background-color: white;
                                                  "
                                                  align="center"
                                                >
                                                  <div>{{ aduls }}</div>
                                                </div>
                                                <div
                                                  class="col-4 formbuttons text-center"
                                                  @click="add1()"
                                                  style="
                                                    background-color: #c62a82;
                                                    color: white;
                                                  "
                                                >
                                                  <div class="adult-plus">
                                                    +
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!-- <div>{{ item.name }}</div> -->
                                          </div>

                                          <div
                                            class="row d-flex align-center my-2 mx-1"
                                            @click.stop
                                          >
                                            <div
                                              class="col-4 d-flex flex-column pe-0"
                                              style="width: 38%"
                                            >
                                              <span
                                                style="
                                                  font-size: 14px;
                                                  font-weight: 500;
                                                  color: #4e4d4d;
                                                "
                                                >Child</span
                                              >
                                              <span
                                                style="
                                                  font-size: 11px;
                                                  color: #4e4d4d;
                                                "
                                                >2-11 yrs</span
                                              >
                                            </div>
                                            <div
                                              class="col-2 px-0"
                                              style="width: 9%"
                                            >
                                              <v-icon
                                                style="
                                                  width: auto;
                                                  color: grey;
                                                  font-size: 18px;
                                                "
                                              >
                                                mdi-human-child
                                              </v-icon>
                                            </div>
                                            <div
                                              class="col-6 adult"
                                              style="width: 50%"
                                            >
                                              <div
                                                class="row"
                                                style="padding: 0px"
                                              >
                                                <div
                                                  class="col-4 formbuttons text-center"
                                                  @click="deg2()"
                                                  style="
                                                    background-color: #c62a82;
                                                    color: white;
                                                  "
                                                >
                                                  <div class="adult-plus">
                                                    -
                                                  </div>
                                                </div>
                                                <div
                                                  class="col-4"
                                                  style="
                                                    background-color: white;
                                                  "
                                                  align="center"
                                                >
                                                  <div>{{ aduls1 }}</div>
                                                </div>
                                                <div
                                                  class="col-4 formbuttons text-center"
                                                  @click="add2()"
                                                  style="
                                                    background-color: #c62a82;
                                                    color: white;
                                                  "
                                                >
                                                  <div class="adult-plus">
                                                    +
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!-- <div>{{ item.name }}</div> -->
                                          </div>

                                          <div
                                            class="row d-flex align-center my-2 mx-1"
                                            @click.stop
                                          >
                                            <div
                                              class="col-5 d-flex flex-column pe-0"
                                              style="width: 38%"
                                            >
                                              <span
                                                style="
                                                  font-size: 14px;
                                                  font-weight: 500;
                                                  color: #4e4d4d;
                                                "
                                                >LapInfant</span
                                              >
                                              <span
                                                style="
                                                  font-size: 11px;
                                                  color: #4e4d4d;
                                                "
                                                >2 yrs</span
                                              >
                                            </div>

                                            <div
                                              class="col-1 ps-0"
                                              style="width: 9%"
                                            >
                                              <v-icon
                                                style="
                                                  width: auto;
                                                  color: grey;
                                                  font-size: 18px;
                                                "
                                              >
                                                mdi-baby-buggy
                                              </v-icon>
                                            </div>
                                            <div
                                              class="col-6 adult"
                                              style="width: 50%"
                                            >
                                              <div
                                                class="row"
                                                style="padding: 0px"
                                              >
                                                <div
                                                  class="col-4 formbuttons text-center"
                                                  @click="deg3()"
                                                  style="
                                                    background-color: #c62a82;
                                                    color: white;
                                                  "
                                                >
                                                  <div class="adult-plus">
                                                    -
                                                  </div>
                                                </div>
                                                <div
                                                  class="col-4"
                                                  style="
                                                    background-color: white;
                                                  "
                                                  align="center"
                                                >
                                                  <div>{{ aduls2 }}</div>
                                                </div>
                                                <div
                                                  class="col-4 formbuttons text-center"
                                                  @click="add3()"
                                                  style="
                                                    background-color: #c62a82;
                                                    color: white;
                                                  "
                                                >
                                                  <div class="adult-plus">
                                                    +
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div
                                            class="mt-4 pe-3 d-flex justify-end"
                                            @click="
                                              (travels = false),
                                                localdone(),
                                                closeDropdown()
                                            "
                                          >
                                            <v-btn
                                              rounded="3"
                                              color="#c62a82"
                                              width="100px"
                                              height="30px"
                                              style="color: white"
                                            >Done
                                            </v-btn>
                                          </div>
                                        </div>
                                      </template>

                                      <template #selection="{}">
                                        <div class="pax-fonts">
                                          <span class="adt-chd"
                                            >{{ aduls }} Adt</span
                                          >
                                          <span
                                            v-if="aduls1 > 0"
                                            class="adt-chd"
                                            >, {{ aduls1 }} ch</span
                                          >
                                          <span
                                            v-if="aduls2 > 0"
                                            class="adt-chd"
                                            >, {{ aduls2 }} Inf</span
                                          >

                                          <!-- <span class="adt-chd"
                                            >, {{ classType }}</span
                                          > -->
                                        </div>
                                      </template>
                                    </v-select>
                                  </div>
                            </div>
                          </div>
                            </div>
                          </div>

                          
                         

                          <div class="col-12">
                            <div class="row">
                              <div v-if="rount || Oneway" class="mb-0">
                                <v-form class="booking-form">
                                  <div class="py-2 px-2 row d-flex flex-row justify-content-between mobileForm">
                                    <div class="col-md-5 col-12 fromInput" @click="clickFocus()">
                                      <div class="form-grp">
                                        <div class="labelTop">
                                          <p class="m-0">From</p>
                                        </div>
                                        <div class="d-block input-styles align-center rounded-border mb-md-2 mb-0">
                                          <div class="vas-autocomplete">
                                            <div class="d-flex row align-center justify-content-between pe-4">
                                              <div class="ps-2 pe-0">
                                                <input
                                                  type="text"
                                                  v-model="oneway.from"
                                                  placeholder="Flying From"
                                                  @keyup="typeCity(oneway.from, 1)"
                                                  class="inter-input form-input"
                                                  @click="
                                                    (oneway.from = ''),
                                                    (formres = true),
                                                    (formres1 = false);
                                                    city1 = [];"
                                                  @change="onChangeFrom()"
                                                  ref="fromAutoComplete"
                                                />
                                              </div>
                                              <!-- <div class="p-0 me-md-2 me-0" v-if="selectedFrom">
                                                <v-icon @click="fromInputData()"
                                                  size="16" color="grey">mdi-close</v-icon>
                                              </div> -->
                                            </div>
                                            <div v-if="typedrop">
                                              <div class="autocompete-menual-dropdown"
                                                v-if="this.city.length > 0">
                                                <div v-for="(data, index) in city" :key="index">
                                                  <div @click="datachange(data)"
                                                    :style="index == city.length - 1 ? '' : 'border-bottom:1px solid lightgray'"
                                                    class="d-flex va-back">
                                                    <div style="display: flex;align-items: center;">
                                                      <v-icon style="transform: rotate(90deg); "
                                                        color="black" size="20">
                                                        {{ data.location === "airport" ? "mdi-airplane" : "mdi-radiobox-marked"}}</v-icon
                                                      >
                                                    </div>

                                                    <div class="m-1 va-content">
                                                      {{ data.iata }},{{
                                                        data.city
                                                      }},{{ data.name }}
                                                    </div>
                                                  </div>
                                                  <!-- -------group--- -->

                                                  <div v-if="data.group_airports.length > 0">
                                                    <div v-for="group in data.group_airports" :key="group">
                                                      <div v-if="data.group_airport_city != group.iata">
                                                        <div class="d-flex va-back" @click="datachange(group)">
                                                          <div style="display: flex;align-items: center;" class="ms-3">
                                                            <v-icon style="transform: rotate(90deg);"
                                                              color="black" size="20"
                                                              >mdi-airplane</v-icon>
                                                          </div>

                                                          <div class="m-1 va-content">
                                                            {{ group.iata }},{{
                                                              group.city
                                                            }},{{ group.name }}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- <div v-if="fromloader">
                                            <div
                                              class="spinner-border spinner-border-sm"
                                              style="
                                                display: flex;
                                                align-items: center;
                                                color: rgb(38 34 94);
                                              "
                                              role="status"
                                            ></div>
                                          </div> -->
                                        </div>
                                        <!-- {{ console.log(fromErrorMessage, maximumletter,'errorMessage') }} -->
                                        <div
                                          class="text-start ps-md-0 ps-2"
                                          v-if="fromErrorMessage"
                                        >
                                          <span
                                            class="p-error wrap-text"
                                            v-if="fromErrorMessage"
                                            >Depature is Required</span
                                          >
                                          <br
                                            v-if="
                                              fromErrorMessage && maximumletter
                                            "
                                          />
                                          <span
                                            class="p-error wrap-text"
                                            v-if="maximumletter"
                                            >Enter Minimum 3 Letters</span
                                          >
                                        </div>
                                      </div>
                                      <!-- <div class="form-wrap">
                                        <label class="checkbox-inline ps-0 d-flex align-center">
                                          <input name="input-group-radio" value="checkbox-1" type="checkbox" class="me-1">Add Nearby Airports
                                        </label>
                                      </div> -->
                                    </div>
                                    <div
                                      class="col-md-5 col-12 ps-2 fromInput"
                                      @click="clickFocusTo()">
                                      <div class="form-grp">
                                        <div
                                          class="labelTop">
                                          <p class="m-0">
                                            To
                                          </p>
                                        </div>
                                        <div
                                          class="d-block input-styles align-center rounded-border roundLabel mb-md-2 mb-0"
                                          @click="formres1 = true"
                                        >
                                          <div class="vas-autocomplete">
                                            <div>
                                              <div>
                                                <input
                                                  type="text"
                                                  v-model="oneway.to"
                                                  @keyup="typeCity(oneway.to, 2)"
                                                  placeholder="Flying To"
                                                  class="inter-input form-input"
                                                  @click="
                                                    (oneway.to = ''),
                                                      (formres1 = true),
                                                      (formres = false),
                                                      (city = [])
                                                  "
                                                  @change="onChangeTo()"
                                                  ref="toAutoComplete"
                                                />
                                              </div>
                                              <!-- <div v-if="selectedTo">
                                                <v-icon
                                                  @click="toInputData()"
                                                  size="16"
                                                  color="grey"
                                                  >mdi-close</v-icon
                                                >
                                              </div> -->
                                            </div>
                                            <div v-if="typedrop1">
                                              <div
                                                class="autocompete-menual-dropdown"
                                                v-if="this.city1.length > 0"
                                              >
                                                <div
                                                  v-for="(data, index) in city1"
                                                  :key="index"
                                                >
                                                  <div
                                                    @click="datachangeTo(data)"
                                                    :style="
                                                      index == city1.length - 1
                                                        ? ''
                                                        : 'border-bottom:1px solid lightgray'
                                                    "
                                                    class="d-flex va-back"
                                                  >
                                                    <div
                                                      style="
                                                        display: flex;
                                                        align-items: center;
                                                      "
                                                    >
                                                      <v-icon
                                                        style="
                                                          transform: rotate(
                                                            90deg
                                                          );
                                                        "
                                                        color="black"
                                                        size="20"
                                                      >
                                                        {{
                                                          data.location ===
                                                          "airport"
                                                            ? "mdi-airplane"
                                                            : "mdi-radiobox-marked"
                                                        }}
                                                      </v-icon>
                                                    </div>

                                                    <div class="m-1 va-content">
                                                      {{ data.iata }},{{
                                                        data.city
                                                      }},{{ data.name }}
                                                    </div>
                                                  </div>

                                                  <div
                                                    class="ms-3"
                                                    v-if="
                                                      data.group_airports
                                                        .length > 0
                                                    "
                                                  >
                                                    <div
                                                      v-for="group in data.group_airports"
                                                      :key="group"
                                                    >
                                                      <div
                                                        v-if="
                                                          data.group_airport_city !=
                                                          group.iata
                                                        "
                                                      >
                                                        <div
                                                          class="d-flex va-back"
                                                          @click="
                                                            datachangeTo(group)
                                                          "
                                                        >
                                                          <div
                                                            style="
                                                              display: flex;
                                                              align-items: center;
                                                            "
                                                          >
                                                            <v-icon
                                                              style="
                                                                transform: rotate(
                                                                  90deg
                                                                );
                                                              "
                                                              color="black"
                                                              size="20"
                                                              >mdi-airplane</v-icon
                                                            >
                                                          </div>

                                                          <div
                                                            class="m-1 va-content"
                                                          >
                                                            {{ group.iata }},{{
                                                              group.city
                                                            }},{{ group.name }}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- <div v-if="toloader">
                                            <div
                                              class="spinner-border spinner-border-sm"
                                              style="
                                                display: flex;
                                                align-items: center;
                                                color: rgb(38 34 94);
                                              "
                                              role="status"
                                            ></div>
                                          </div> -->
                                        </div>
                                        <!-- {{ console.log(toErrorMessage,maximumletter1,'errorMessageTo') }} -->
                                        <div
                                          class="text-start ps-md-0 ps-2"
                                          v-if="toErrorMessage">
                                          <span
                                            class="p-error wrap-text"
                                            v-if="toErrorMessage"
                                            >Arrival is Required</span>
                                          <br v-if="toErrorMessage && maximumletter1"/>
                                          <span
                                            class="p-error wrap-text"
                                            v-if="maximumletter1">Enter Minimum 3 Letters</span>
                                        </div>
                                      </div>
                                      <!-- <div class="form-wrap">
                                        <label class="checkbox-inline ps-0 d-flex align-center">
                                          <input name="input-group-radio" value="checkbox-1" type="checkbox" class="me-1">Add Nearby Airports
                                        </label>
                                      </div> -->
                                    </div>
                                    <div class="col-lg-2">
                                      <div class="form-grp">
                                      <div class="labelTop">
                                          <p class="m-0">Cabin Class</p>
                                        </div>
                                      <v-select v-model="classType"
                                        :items="classTypeitems" ref="mySelect"
                                        class="select-2"
                                        item-title="value" style="color: black">
                                        <template v-slot:item="{ props, item, index }">
                                          <v-list-item v-bind="props"
                                            :subtitle="item.department" @click="selectClasstype(item, index)">
                                          </v-list-item>
                                        </template>
                                      </v-select>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row ps-2 d-flex">
                                    <div class="col-md-3 col-12 ps-2 fromInput mb-0">
                                      <div class="form-grp date">
                                          <div>
                                            <div class="labelTop">
                                              <p class="m-0 ps-0">
                                                Depart Date
                                              </p>
                                            </div>

                                            <div
                                              class="d-block input-styles align-center rounded-border pe-0 me-0 mb-1"
                                            >
                                              <span class="p-float-label">
                                                <VueDatePicker
                                                  ref="dpRef1"
                                                  v-model="oneway.dedate"
                                                  placeholder="Depart Date"
                                                  :min-date="new Date()"
                                                  :six-weeks="sixWeekMode"
                                                  :max-date="
                                                    new Date(
                                                      new Date().getFullYear() +
                                                        1,
                                                      new Date().getMonth(),
                                                      new Date().getDate()
                                                    )
                                                  "
                                                  :format="dateFormat"
                                                  :hide-navigation="['time']"
                                                  auto-apply
                                                  :multi-calendars="multiCalender"
                                                  @update:modelValue="fromDateChanged"
                                                  :on-click-outside="ClickOutDepat"
                                                  class="px-0 roundFromTime">
                                                  <template #clear-icon="{}">
                                                  <v-icon class="input-slot-image me-2"
                                                  @click="clearDate(oneway.dedate, 'dep')">mdi-close-circle</v-icon>
                                                </template>
                                              </VueDatePicker>
                                              </span>
                                            </div>
                                            <div
                                              class="text-start"
                                              v-if="fromDateError"
                                            >
                                              <span
                                                class="p-error wrap-text"
                                                style="
                                                  word-wrap: break-word;
                                                  white-space: normal;
                                                  max-width: 48%;
                                                "
                                                >Depart Date is Required</span
                                              >
                                            </div>
                                          </div>
                                      </div>
                                    </div>
                                    <div class="col-md-3 col-12 ps-2 pe-3 fromInput mb-0">
                                      <div class="form-grp date">
                                          <div :class="{ disable: Oneway }">
                                            <div class="labelTop">
                                              <p class="m-0 ps-0">
                                                Return Date
                                              </p>
                                            </div>
                                            <div
                                              class="d-block input-styles align-center rounded-border pe-0 me-0 mb-1"
                                            >
                                              <span class="p-float-label">
                                                <VueDatePicker
                                                  ref="dpRef2"
                                                  v-model="oneway.redate"
                                                  placeholder="Return Date"
                                                  :format="dateFormat"
                                                  no-today
                                                  :six-weeks="sixWeekMode"
                                                  :start-date="oneway.dedate"
                                                  :multi-calendars="multiCalender"
                                                  v-if="rount"
                                                  :disabled="red1 === 'oneway'"
                                                  :min-date="
                                                    oneway.dedate
                                                      ? oneway.dedate
                                                      : new Date()
                                                  "
                                                  :max-date="
                                                    new Date(
                                                      new Date().getFullYear() +
                                                        1,
                                                      new Date().getMonth(),
                                                      new Date().getDate()
                                                    )
                                                  "
                                                  :hide-navigation="['time']"
                                                  auto-apply
                                                  :on-click-outside="ClickOutReturn"
                                                  @update:modelValue="toDateChanged"
                                                  class="roundToTime">
                                                <template #clear-icon="{}">
                                                  <v-icon class="input-slot-image me-2"
                                                  @click="clearDate(oneway.dedate, 'der')">mdi-close-circle</v-icon>
                                                </template>
                                                </VueDatePicker>
                                                <VueDatePicker
                                                  v-model="date"
                                                  placeholder="Return Date"
                                                  v-if="!rount"
                                                  class="roundToTime"
                                                />

                                                <!-- <span class="p-error" v-if="toDateError">Arr. Date is required</span> -->
                                              </span>
                                            </div>
                                            <div
                                              class="text-start"
                                              v-if="toDateError"
                                            >
                                              <span
                                                class="p-error wrap-text"
                                                v-if="toDateError"
                                                >Return Date is Required</span
                                              >
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                       <div class="col-lg-3" style="margin-bottom:0px !important;">
                                        <div class="labelTop">
                                          <p class="m-0"> Passenger</p>
                                        </div>
                            <div class="form-wrap">
                              <div class="input-styles-2 select-option rounded-border">
                                    <v-select
                                      v-model="selectedCountry"
                                      :items="countries"
                                      ref="countrySelect"
                                      style="position: relative; top: 0px"
                                      class="select-1"
                                    >
                                      <!-- <template #item="{ item }"> -->
                                      <template #item="{}">
                                        <div class="dropdown_section" style="cursor: pointer">
                                          <div
                                            class="row d-flex align-center my-2 mx-1"
                                            @click.stop>
                                            <div
                                              class="col-3"
                                              style="width: 38%"
                                            >
                                              <span
                                                style="
                                                  font-size: 14px;
                                                  font-weight: 500;
                                                  color: #4e4d4d;
                                                "
                                                >Adult</span
                                              >
                                            </div>
                                            <div
                                              class="col-3 px-0"
                                              style="width: 9%"
                                            >
                                              <v-icon
                                                style="
                                                  width: auto;
                                                  color: grey;
                                                  font-size: 18px;
                                                "
                                              >
                                                mdi-human-male-female
                                              </v-icon>
                                            </div>
                                            <div
                                              class="col-6 adult"
                                              style="width: 50%; height: auto"
                                            >
                                              <div
                                                class="row"
                                                style="padding: 0px"
                                              >
                                                <div
                                                  class="col-4 formbuttons text-center"
                                                  @click="deg1()"
                                                  style="
                                                    background-color: #c62a82;
                                                    color: white;
                                                  "
                                                >
                                                  <div class="adult-plus">
                                                    -
                                                  </div>
                                                </div>
                                                <div
                                                  class="col-4"
                                                  style="
                                                    background-color: white;
                                                  "
                                                  align="center"
                                                >
                                                  <div>{{ aduls }}</div>
                                                </div>
                                                <div
                                                  class="col-4 formbuttons text-center"
                                                  @click="add1()"
                                                  style="
                                                    background-color: #c62a82;
                                                    color: white;
                                                  "
                                                >
                                                  <div class="adult-plus">
                                                    +
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!-- <div>{{ item.name }}</div> -->
                                          </div>

                                          <div
                                            class="row d-flex align-center my-2 mx-1"
                                            @click.stop
                                          >
                                            <div
                                              class="col-4 d-flex flex-column pe-0"
                                              style="width: 38%"
                                            >
                                              <span
                                                style="
                                                  font-size: 14px;
                                                  font-weight: 500;
                                                  color: #4e4d4d;
                                                "
                                                >Child</span
                                              >
                                              <span
                                                style="
                                                  font-size: 11px;
                                                  color: #4e4d4d;
                                                "
                                                >2-11 yrs</span
                                              >
                                            </div>
                                            <div
                                              class="col-2 px-0"
                                              style="width: 9%"
                                            >
                                              <v-icon
                                                style="
                                                  width: auto;
                                                  color: grey;
                                                  font-size: 18px;
                                                "
                                              >
                                                mdi-human-child
                                              </v-icon>
                                            </div>
                                            <div
                                              class="col-6 adult"
                                              style="width: 50%"
                                            >
                                              <div
                                                class="row"
                                                style="padding: 0px"
                                              >
                                                <div
                                                  class="col-4 formbuttons text-center"
                                                  @click="deg2()"
                                                  style="
                                                    background-color: #c62a82;
                                                    color: white;
                                                  "
                                                >
                                                  <div class="adult-plus">
                                                    -
                                                  </div>
                                                </div>
                                                <div
                                                  class="col-4"
                                                  style="
                                                    background-color: white;
                                                  "
                                                  align="center"
                                                >
                                                  <div>{{ aduls1 }}</div>
                                                </div>
                                                <div
                                                  class="col-4 formbuttons text-center"
                                                  @click="add2()"
                                                  style="
                                                    background-color: #c62a82;
                                                    color: white;
                                                  "
                                                >
                                                  <div class="adult-plus">
                                                    +
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!-- <div>{{ item.name }}</div> -->
                                          </div>

                                          <div
                                            class="row d-flex align-center my-2 mx-1"
                                            @click.stop
                                          >
                                            <div
                                              class="col-5 d-flex flex-column pe-0"
                                              style="width: 38%"
                                            >
                                              <span
                                                style="
                                                  font-size: 14px;
                                                  font-weight: 500;
                                                  color: #4e4d4d;
                                                "
                                                >LapInfant</span
                                              >
                                              <span
                                                style="
                                                  font-size: 11px;
                                                  color: #4e4d4d;
                                                "
                                                >2 yrs</span
                                              >
                                            </div>

                                            <div
                                              class="col-1 ps-0"
                                              style="width: 9%"
                                            >
                                              <v-icon
                                                style="
                                                  width: auto;
                                                  color: grey;
                                                  font-size: 18px;
                                                "
                                              >
                                                mdi-baby-buggy
                                              </v-icon>
                                            </div>
                                            <div
                                              class="col-6 adult"
                                              style="width: 50%"
                                            >
                                              <div
                                                class="row"
                                                style="padding: 0px"
                                              >
                                                <div
                                                  class="col-4 formbuttons text-center"
                                                  @click="deg3()"
                                                  style="
                                                    background-color: #c62a82;
                                                    color: white;
                                                  "
                                                >
                                                  <div class="adult-plus">
                                                    -
                                                  </div>
                                                </div>
                                                <div
                                                  class="col-4"
                                                  style="
                                                    background-color: white;
                                                  "
                                                  align="center"
                                                >
                                                  <div>{{ aduls2 }}</div>
                                                </div>
                                                <div
                                                  class="col-4 formbuttons text-center"
                                                  @click="add3()"
                                                  style="
                                                    background-color: #c62a82;
                                                    color: white;
                                                  "
                                                >
                                                  <div class="adult-plus">
                                                    +
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div
                                            class="mt-4 pe-3 d-flex justify-end"
                                            @click="
                                              (travels = false),
                                                localdone(),
                                                closeDropdown()
                                            "
                                          >
                                            <v-btn
                                              rounded="3"
                                              color="#c62a82"
                                              width="100px"
                                              height="30px"
                                              style="color: white"
                                            >Done
                                            </v-btn>
                                          </div>
                                        </div>
                                      </template>

                                      <template #selection="{}">
                                        <div class="pax-fonts">
                                          <span class="adt-chd"
                                            >{{ aduls }} Adt</span
                                          >
                                          <span
                                            v-if="aduls1 > 0"
                                            class="adt-chd"
                                            >, {{ aduls1 }} ch</span
                                          >
                                          <span
                                            v-if="aduls2 > 0"
                                            class="adt-chd"
                                            >, {{ aduls2 }} Inf</span
                                          >

                                          <!-- <span class="adt-chd"
                                            >, {{ classType }}</span
                                          > -->
                                        </div>
                                      </template>
                                    </v-select>
                                  </div>
                            </div>
                          </div>
                          <div v-if="!multicity" class="col-lg-3 col-sm-3 align-center text-center mb-0 d-flex justify-center text-xl-right" :class="{'mt-0': fromDateError, 'mt-4': !fromDateError}">
                                <button class="button button-primary button-sm button-naira button-naira-up" style="padding: 14px 35px 13px;" @click.prevent="sended()"><span class="icon fa-search"></span><span>Search Flight</span></button>
                              </div>
                              <!-- <div v-if="!multicity">
                                <v-btn style="background-color:blue;color:white;" @click="sended()">Search Flight</v-btn>
                              </div> -->
                                  </div>
                                </v-form>
                              </div>
                              <div class="my-4 my-md-0 mt-5" v-if="multicity">
                                <v-form style="border-radius: 8px">
                                  <div
                                    class="row multicity m-0"
                                    v-for="(data, index) of multiData.itinery"
                                    :key="index"
                                  >
                                    <div
                                      class="multiData py-2 pb-3 px-0 row d-flex flex-md-row flex-column align-center justify-content-between"
                                      style="
                                        margin: 0;
                                        border-radius: 5px;">
                                      <div
                                        class="col-lg-3 col-12 p-0 fromInput"
                                        @click="clickMultiFrom(index)"
                                      >
                                        <div class="form-grp">
                                          <div class="labelTop">
                                            <p class="m-0">
                                              Flight {{ index + 1 }} From
                                            </p>
                                          </div>
                                          <div
                                            class="d-block input-styles align-center rounded-border"
                                          >
                                            <div class="vas-autocomplete">
                                              <div>
                                                <div>
                                                  <input
                                                    type="text"
                                                    style="cursor: pointer"
                                                    placeholder="Flying From"
                                                    v-model="data.from"
                                                    @click="
                                                      multiData.itinery[index].from = ''"
                                                    @keyup="typeMultiCity(data.from,index,1)"
                                                    ref="multiFromAutocomplete"
                                                    class="inter-input form-input"
                                                  />
                                                </div>
                                                <!-- <div v-if="data.selectedFrom">
                                                  <v-icon
                                                    @click="multiFrom(index)"
                                                    size="16"
                                                    color="grey"
                                                    >mdi-close</v-icon
                                                  >
                                                </div> -->
                                              </div>
                                              <!-- {{console.log(data,'data.autocomfrom')}} -->
                                              <div
                                                v-if="
                                                  multiData.itinery[index]
                                                    .autocomfrom
                                                    ? true
                                                    : false
                                                "
                                              >
                                                <div
                                                  class="autocompete-menual-dropdown"
                                                  v-if="
                                                    this.multidrop.length > 0
                                                      ? true
                                                      : false
                                                  "
                                                >
                                                  <div
                                                    v-for="(
                                                      data1, index1
                                                    ) in multidrop"
                                                    :key="index1"
                                                  >
                                                    {{
                                                      console.log(
                                                        data1,
                                                        "data1data1"
                                                      )
                                                    }}
                                                    <div
                                                      @click="
                                                        datachangeMuti(
                                                          data1,
                                                          index
                                                        )
                                                      "
                                                      :style="
                                                        index1 ==
                                                        multidrop.length - 1
                                                          ? ''
                                                          : 'border-bottom:1px solid lightgray'
                                                      "
                                                      class="d-flex p-2 va-back"
                                                    >
                                                      <div
                                                        style="
                                                          display: flex;
                                                          align-items: center;
                                                        "
                                                      >
                                                        <v-icon
                                                          style="
                                                            transform: rotate(
                                                              90deg
                                                            );
                                                          "
                                                          color="black"
                                                          size="20"
                                                          >mdi-airplane</v-icon
                                                        >
                                                      </div>

                                                      <div
                                                        class="ms-1 va-content"
                                                      >
                                                        {{ data1.iata }},
                                                        {{ data1.city }},
                                                        {{ data1.name }}
                                                      </div>
                                                    </div>

                                                    <div
                                                      v-if="
                                                        data1.group_airports
                                                          .length > 0
                                                      "
                                                    >
                                                      <div
                                                        v-for="(
                                                          group, index1
                                                        ) in data1.group_airports"
                                                        :key="index1"
                                                      >
                                                        <div
                                                          v-if="
                                                            data1.group_airport_city !=
                                                            group.iata
                                                          "
                                                        >
                                                          <div
                                                            class="d-flex va-back"
                                                            @click="
                                                              datachangeMuti(
                                                                group,
                                                                index1
                                                              )
                                                            "
                                                          >
                                                            <div
                                                              style="
                                                                display: flex;
                                                                align-items: center;
                                                              "
                                                              class="ms-3"
                                                            >
                                                              <v-icon
                                                                style="
                                                                  transform: rotate(
                                                                    90deg
                                                                  );
                                                                "
                                                                color="black"
                                                                size="20"
                                                                >mdi-airplane</v-icon
                                                              >
                                                            </div>

                                                            <div
                                                              class="m-1 va-content"
                                                            >
                                                              {{ group.iata }},
                                                              {{ group.city }},
                                                              {{ group.name }}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!-- <div v-if="data.autocomfrom">
                                              <div
                                                class="spinner-border spinner-border-sm"
                                                style="
                                                  display: flex;
                                                  align-items: center;
                                                  color: rgb(38 34 94);
                                                "
                                                role="status"
                                              ></div>
                                            </div> -->
                                          </div>

                                          <div class="text-start ps-2">
                                            <span
                                              class="p-error"
                                              v-if="data.multiFromError"
                                              >Depature is Required</span
                                            >
                                            <br
                                              v-if="
                                                data.multiFromError &&
                                                data.maximumletter
                                              "
                                            />
                                            <span
                                              class="p-error"
                                              v-if="data.maximumletter"
                                              >Enter Minimum 3 Letters</span
                                            >
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="col-lg-3 col-12 p-0 fromInput"
                                        @click="clickMultiFrom(index)">
                                        <div class="form-grp">
                                          <div class="labelTop">
                                            <p class="m-0">
                                              Flight {{ index + 1 }} To
                                            </p>
                                          </div>
                                          <div
                                            class="d-block input-styles align-center rounded-border"
                                            @click="formres1 = true">
                                            <div class="vas-autocomplete">
                                              <div>
                                                <div>
                                                  <input
                                                    style="cursor: pointer"
                                                    type="text"
                                                    placeholder="Flying To"
                                                    v-model="data.to"
                                                    @click="multiData.itinery[index].to = ''"
                                                    @keyup="typeMultiCity(data.to,index,2)"
                                                    ref="multiToAutocomplete"
                                                    class="inter-input form-input"
                                                  />
                                                </div>
                                                <!-- <div v-if="data.selectedTo">
                                                  <v-icon
                                                    @click="multiTo(index)"
                                                    size="16"
                                                    color="grey"
                                                    >mdi-close</v-icon
                                                  >
                                                </div> -->
                                              </div>

                                              <div v-if="data.autocomTo">
                                                <div
                                                  class="autocompete-menual-dropdown"
                                                  v-if="
                                                    multidrop1.length > 0
                                                      ? true
                                                      : false">
                                                  <div
                                                    v-for="(
                                                      data, index1
                                                    ) in multidrop1"
                                                    :key="index1"
                                                  >
                                                    <div
                                                      @click="
                                                        datachangeMutiTo(
                                                          data,
                                                          index
                                                        )
                                                      "
                                                      :style="
                                                        index1 ==
                                                        multidrop1.length - 1
                                                          ? ''
                                                          : 'border-bottom:1px solid lightgray'
                                                      "
                                                      class="d-flex p-2 va-back"
                                                    >
                                                      <div
                                                        style="
                                                          display: flex;
                                                          align-items: center;
                                                        "
                                                      >
                                                        <v-icon
                                                          style="
                                                            transform: rotate(
                                                              90deg
                                                            );
                                                          "
                                                          color="black"
                                                          size="20"
                                                        >
                                                          {{
                                                            data.location ===
                                                            "airport"
                                                              ? "mdi-airplane"
                                                              : "mdi-radiobox-marked"
                                                          }}
                                                        </v-icon>
                                                      </div>

                                                      <div
                                                        class="ms-1 va-content"
                                                      >
                                                        {{ data.iata }},
                                                        {{ data.city }},
                                                        {{ data.name }}
                                                      </div>
                                                    </div>

                                                    <div
                                                      v-if="
                                                        data.group_airports
                                                          .length > 0
                                                      "
                                                    >
                                                      <div
                                                        v-for="(
                                                          group, index1
                                                        ) in data.group_airports"
                                                        :key="index1"
                                                      >
                                                        <div
                                                          v-if="
                                                            data.group_airport_city !=
                                                            group.iata
                                                          "
                                                        >
                                                          <div
                                                            class="d-flex va-back"
                                                            @click="
                                                              datachangeMutiTo(
                                                                group,
                                                                index1
                                                              )
                                                            "
                                                          >
                                                            <div
                                                              style="
                                                                display: flex;
                                                                align-items: center;
                                                              "
                                                              class="ms-3"
                                                            >
                                                              <v-icon
                                                                style="
                                                                  transform: rotate(
                                                                    90deg
                                                                  );
                                                                "
                                                                color="black"
                                                                size="20"
                                                                >mdi-airplane</v-icon
                                                              >
                                                            </div>

                                                            <div
                                                              class="m-1 va-content"
                                                            >
                                                              {{ group.iata }},
                                                              {{ group.city }},
                                                              {{ group.name }}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            <!-- <div v-if="data.autocomTo">
                                              <div
                                                class="spinner-border spinner-border-sm"
                                                style="
                                                  display: flex;
                                                  align-items: center;
                                                  color: rgb(38 34 94);
                                                "
                                                role="status"
                                              ></div>
                                            </div> -->
                                          </div>
                                          <div class="text-start ps-2">
                                            <span
                                              class="p-error"
                                              v-if="data.multiToError"
                                              >Arrival is Required</span
                                            >
                                            <br
                                              v-if="
                                                data.multiToError &&
                                                data.maximumletter1
                                              "
                                            />
                                            <span
                                              class="p-error"
                                              v-if="data.maximumletter1"
                                              >Enter Minimum 3 Letters</span
                                            >
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-lg-3 col-12 p-0 fromInput">
                                        <div class="form-grp date">
                                          <div>
                                            <div class="labelTop">
                                              <p class="m-0">
                                                Flight {{ index + 1 }} Date
                                              </p>
                                            </div>

                                            <div
                                              class="d-block input-styles rounded-border pe-0 me-0"
                                            >
                                              <!-- <span class="d-flex align-center ps-1 me-2">
                                                                            <v-icon color="#3c0ec2">mdi-calendar</v-icon>
                                                                        </span> -->

                                              <span
                                                class="p-float-label"
                                              >
                                                <!-- <span :class="clicked1 ? 'label-top' : 'datepicker-label'">
                                                                            Departure
                                                                            </span> -->

                                                <VueDatePicker
                                                  ref="dpRef4"
                                                  v-model="data.departDate"
                                                  :six-weeks="sixWeekMode"
                                                  placeholder="Depart Date"
                                                  :min-date="getdate1(multiData.itinery,index)"
                                                  :start-date="
                                                    getdate1(multiData.itinery,index)"
                                                  :max-date="
                                                    new Date(
                                                      new Date().getFullYear() + 1,
                                                      new Date().getMonth(),
                                                      new Date().getDate()
                                                    )"
                                                  :format="dateFormat"
                                                  :hide-navigation="['time']"
                                                  auto-apply
                                                  :multi-calendars="multiCalender"
                                                  @focus="
                                                    (data.focusMultiEvent3 = true),
                                                      (data.focusMultiEvent1 = false),
                                                      (data.focusMultiEvent2 = false)"
                                                  @update:modelValue="
                                                    (newValue) => multiDateChanged(newValue,index)"
                                                  :month-change-on-scroll="false"
                                                  :on-click-outside="ClickOutDepatMulti"
                                                  class="px-0 multiDate"
                                                />

                                                <!-- <div class="col-12"> -->
                                                <!-- <span class="p-error" v-if="fromDateError">Dep. Date is required</span> -->
                                                <!-- </div> -->
                                              </span>
                                            </div>
                                            <div class="text-start ps-2">
                                              <span
                                                class="p-error"
                                                v-if="data.multiDateError"
                                                >Date is Required</span
                                              >
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-lg-2 col-12 p-0">
                                        <div
                                          class="content-bottom mt-5"
                                        >
                                          <!-- <v-btn
                                            v-if="index == 0 ? true : false"
                                            block
                                            class="d-md-flex d-none search-btn btn m-0"
                                            :disabled="disButton"
                                            @click="sendedMulticity()"
                                            ><span
                                              class="f-size-20 me-1 text-capitalize"
                                              >Search Flight</span
                                            > -->
                                            <button :disabled="disButton" v-if="index == 0 ? true : false"
                                            @click.prevent="sendedMulticity()" class="d-md-flex d-none button button-primary button-sm button-naira button-naira-up"><span class="icon fa-search"></span><span>Search Flight</span></button>
                                          <!-- </v-btn> -->
                                          <div
                                            class="d-flex justify-end"
                                            v-if="index !== 0 ? true : false"
                                          >
                                            <div v-if="index > 1 ? true : false"
                                              style="
                                                display: flex;
                                                align-items: center;
                                                margin-right: 10px;
                                              "
                                            >
                                              <span
                                                style="
                                                  margin: auto;
                                                  cursor: pointer;
                                                "
                                                v-if="index > 1 ? true : false"
                                                @click="deleteItin(index)"
                                              >
                                                <v-icon color="red" size="22">
                                                  mdi-close-circle-outline
                                                </v-icon>
                                              </span>
                                            </div>

                                            <div
                                              v-if="
                                                multiData.itinery.length == 4
                                                  ? false
                                                  : true
                                              "
                                            >
                                              <v-btn
                                                v-if="
                                                  multiData.itinery.length -
                                                    1 ==
                                                    3 ||
                                                  index ==
                                                    multiData.itinery.length - 1
                                                    ? true
                                                    : false
                                                "
                                                class="d-flex align-center formbottom_addBtn"
                                                @click="addTrip(index)"
                                                prepend-icon="mdi-plus-circle"
                                                >Add More</v-btn
                                              >
                                            </div>

                                            <div
                                              v-if="index == 3 ? true : false"
                                            >
                                              <v-btn
                                                class="d-flex align-center formbottom_ClearBtn"
                                                @click="clearall1()"
                                                prepend-icon="mdi-close-box-multiple"
                                                >Clear All</v-btn
                                              >
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </v-form>
                              </div>
                              <div
                                class="content-bottom d-md-none d-flex mb-0 justify-center"
                                v-if="multicity">
                                 <button class="button button-primary button-sm button-naira button-naira-up" style="width:180px;" @click.prevent="sendedMulticity()"><span class="icon fa-search"></span><span>Search Flight</span></button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-form>
                    </div>
                  </div>
                  <div v-if="activeTab == 'recentSearches'" class="resp-tabs-container nav-custom-tab nav-custom-wide">
                     <div
                            v-if="
                              this.RecentSearchData.length > 0 ? true : false
                            "
                          >
                            <div class="row">
                              <div
                                class="col-md-4 mt-2"
                                v-for="data of this.RecentSearchData"
                                :key="data"
                              >
                                <div v-if="!data.itinery">
                                  <v-card
                                    @click="cardassigndata(data)"
                                    class="pa-2"
                                  >
                                    <div class="row">
                                      <div class="col-5">
                                        <div class="re-fon">
                                          {{ data.from }}
                                        </div>
                                        <div class="re-fon">
                                          {{ getdated(data.fromDate) }}
                                        </div>
                                      </div>
                                      <div class="col-2">
                                        <div v-if="data.city == 1">
                                          <v-icon>mdi-swap-horizontal</v-icon>
                                        </div>
                                        <div v-if="data.city == 2">
                                          <v-icon>mdi-arrow-right</v-icon>
                                        </div>
                                        <div v-if="data.city == 3">
                                          <v-icon>mdi-swap-horizontal</v-icon>
                                          <v-icon>mdi-swap-horizontal</v-icon>
                                          <v-icon>mdi-swap-horizontal</v-icon>
                                        </div>
                                      </div>
                                      <div class="col-5">
                                        <div class="re-fon">
                                          {{ data.to }}
                                        </div>
                                        <div class="re-fon" v-if="data.toDate">
                                          {{ getdated(data.toDate) }}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-7">
                                        <div class="re-fon">
                                          Passengers:
                                          <span v-if="data.adult > 0"
                                            >{{ data.adult}}Adt</span>
                                          <span
                                            class="ms-1"
                                            v-if="data.child > 0"
                                            >{{ data.child}}Chl</span>
                                          <span class="ms-1" v-if="data.inf > 0"
                                            >{{ data.inf}}Inf</span>
                                        </div>
                                      </div>
                                      <div
                                        class="col-5 re-fon"
                                        v-if="data.class"
                                      >
                                        Class:
                                        {{ data.class }}
                                      </div>
                                    </div>
                                  </v-card>
                                </div>
                                <div v-if="data.itinery">
                                  <div>
                                    <v-card
                                      @click="cardassigndata(data)"
                                      class="pa-2"
                                    >
                                      <div
                                        class="row"
                                        v-for="(item, index) of data.itinery"
                                        :key="index"
                                      >
                                        <div class="col-5">
                                          <div class="re-fon">
                                            {{ item.from }}
                                          </div>
                                          <div class="re-fon">
                                            {{ getdated(item.departDate) }}
                                          </div>
                                        </div>
                                        <div class="col-2">
                                          <div>
                                            <v-icon>mdi-arrow-right</v-icon>
                                          </div>
                                        </div>
                                        <div class="col-5">
                                          <div class="re-fon">
                                            {{ item.to }}
                                          </div>
                                          <!-- <div class="re-fon" v-if="data.toDate">
                                        {{ getdated(data.toDate) }}
                                      </div> -->
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-7">
                                          <div class="re-fon">
                                            Passengers:
                                            <span v-if="data.adult > 0"
                                              >{{ data.adult}}Adt</span>
                                            <span
                                              class="ms-1"
                                              v-if="data.child > 0"
                                              >{{ data.child}}Chl</span>
                                            <span
                                              class="ms-1"
                                              v-if="data.inf > 0"
                                              >{{ data.inf}}Inf</span>
                                          </div>
                                        </div>
                                        <div
                                          class="col-5 re-fon"
                                          v-if="data.class"
                                        >Class: {{ data.class }}
                                        </div>
                                      </div>
                                    </v-card>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="section-60 section-xl-top-30 section-xl-bottom-30 bg-gray-lighter">
        <div class="container-wide">
          <div class="wow fadeInUp" data-wow-delay="0.1s">
            <!-- Owl Carousel-->
            <!-- <div class="owl-nav-variant-3 owl-dots-lg owl-carousel owl-carousel-middle owl-dots-primary" data-dots="true" data-nav="true" data-items="3" data-sm-items="4" data-md-items="5" data-lg-items="5" data-xl-items="6" data-margin="30" data-mouse-drag="false"><a class="thumbnail-opacity" href="#"><img class="img-responsive" src="../assets/images/logo-14.png" width="107" height="74" alt=""></a><a class="thumbnail-opacity" href="#"><img class="img-responsive" src="../assets/images/logo-15.png" width="190" height="17" alt=""></a><a class="thumbnail-opacity" href="#"><img class="img-responsive" src="../assets/images/logo-16.png" width="151" height="71" alt=""></a><a class="thumbnail-opacity" href="#"><img class="img-responsive" src="../assets/images/logo-17.png" width="163" height="46" alt=""></a><a class="thumbnail-opacity" href="#"><img class="img-responsive" src="../assets/images/logo-18.png" width="183" height="68" alt=""></a><a class="thumbnail-opacity" href="#"><img class="img-responsive" src="../assets/images/logo-19.png" width="178" height="53" alt=""></a><a class="thumbnail-opacity" href="#"><img class="img-responsive" src="../assets/images/logo-14.png" width="107" height="74" alt=""></a><a class="thumbnail-opacity" href="#"><img class="img-responsive" src="../assets/images/logo-15.png" width="190" height="17" alt=""></a><a class="thumbnail-opacity" href="#"><img class="img-responsive" src="../assets/images/logo-16.png" width="151" height="71" alt=""></a><a class="thumbnail-opacity" href="#"><img class="img-responsive" src="../assets/images/logo-17.png" width="163" height="46" alt=""></a><a class="thumbnail-opacity" href="#"><img class="img-responsive" src="../assets/images/logo-18.png" width="183" height="68" alt=""></a><a class="thumbnail-opacity" href="#"><img class="img-responsive" src="../assets/images/logo-19.png" width="178" height="53" alt=""></a><a class="thumbnail-opacity" href="#"><img class="img-responsive" src="../assets/images/logo-15.png" width="190" height="17" alt=""></a></div> -->
            <v-sheet style="background-color:#f3f4f7;"
            >
              <v-slide-group
                v-model="model"
                class="pa-4"
                selected-class="bg-success"
                show-arrows
              >
                <v-slide-group-item
                  v-for="n in carousels"
                  :key="n"
                  
                >
                  <!-- <v-card
                    :class="['ma-4']"
                    color="grey-lighten-1"
                    height="200"
                    width="100"
                  > -->
                    <!-- <div class="d-flex fill-height align-center justify-center">
                      <v-scale-transition>
                        <v-icon
                          v-if="isSelected"
                          color="white"
                          icon="mdi-close-circle-outline"
                          size="48"
                        ></v-icon>
                      </v-scale-transition>
                    </div> -->
                    <img :src="n.image" class="px-5 gx-2" style="width:100%;object-fit:contain;"/>
                  <!-- </v-card> -->
                </v-slide-group-item>
              </v-slide-group>
            </v-sheet>
          </div>
        </div>
      </section>
      <section class="section-80 section-lg-40">
        <div class="container container-wide">
          <h5 class="view-animate fadeInUpBigger delay-04 text-info-dr">Why People Choose Us</h5>
          <h2 class="view-animate fadeInUpBigger delay-04" style="margin-bottom: 60px;font-size: 48px;font-weight: 600;">Our Advantages</h2>
          <!-- <hr class="view-animate fadeInUpBigger delay-06 divider divider-primary divider-80"> -->
          <div class="row row-50">
            <div class="col-md-6 col-lg-3 icon-box view-animate fadeInUpSmall delay-08" v-for="(data,index) of whyChoose" :key="index"><span class="icon icon-lg text-primary-grad icon-primary icon-circle" :class="data.icon"></span>
              <h5 class="text-bold" style="margin-bottom:30px;">{{ data.heading1 }}<br class="d-sm-none d-md-block d-lg-block">{{ data.heading2}}</h5>
              <!-- <hr class="divider divider-info divider-50"> -->
              <p class="inset-xxl-left-40 inset-xxl-right-40">{{ data.content }}</p>
            </div>
            <!-- <div class="col-md-6 col-lg-3 icon-box view-animate fadeInUpSmall delay-08"><span class="icon icon-lg text-primary-grad icon-primary icon-circle mdi mdi-account-multiple"></span>
              <h5 class="text-bold" style="margin-bottom:30px;">More Than 7M Visitors<br class="d-none d-lg-block">Each Month</h5>
              <p class="inset-xxl-left-40 inset-xxl-right-40">More than 7 million people use our services to find and book airline tickets.</p>
            </div>
            <div class="col-md-6 col-lg-3 icon-box view-animate fadeInUpSmall delay-08"><span class="icon icon-lg text-primary-grad icon-primary icon-circle fa-search"></span>
              <h5 class="text-bold" style="margin-bottom:30px;">User-Friendly<br class="d-none d-lg-block">Search System</h5>
              <p class="inset-xxl-left-40 inset-xxl-right-40">Convenient and fast search for airline tickets, hotels and cars.</p>
            </div>
            <div class="col-md-6 col-lg-3 icon-box view-animate fadeInUpSmall delay-08"><span class="icon icon-lg text-primary-grad icon-primary icon-circle mdi mdi-calendar-multiple-check" style="font-size: 52px;"></span>
              <h5 class="text-bold" style="margin-bottom:30px;">Fast and Reliable<br class="d-none d-lg-block">Ticket Booking</h5>
              <p class="inset-xxl-left-40 inset-xxl-right-40">We provide reliable ticket booking system, which is also perfect for first-time travellers.</p>
            </div> -->
          </div>
        </div>
      </section>
      <section class="bg-image-05 context-dark section-70 section-xl-40">
        <div class="container parallax-scene-wrapper">
          <div class="row justify-content-sm-center">
            <div class="col-xl-6 col-lg-8 wow fadeInUp" data-wow-delay="0.1s">
              <h1 class="text-spacing-60 text-uppercase text-ubold p">24/7 Support</h1>
              <p class="big">Our Support Service is available 24 hours a day, 7 days a week to help you buy your tickets.</p><a class="button button-primary">get in touch</a>
            </div>
          </div>
        </div>
      </section>
      
      <section class="d-none section-80 section-lg-40 bg-gray-lighter">
        <div class="container container-wide">
          <h5 class="text-info-dr wow fadeInUp" data-wow-delay="0.1s">Recent Blog Posts</h5>
          <h2 class="wow fadeInUp" style="margin-bottom:40px;" data-wow-delay="0.2s">Tips & Tricks</h2>
          <!-- <hr class="divider divider-primary divider-80 wow fadeInUp" data-wow-delay="0.3s"> -->
          <div class="row row-50">
            <div class="col-xl-6 wow fadeInLeft" data-wow-delay="0.2s">
              <!-- Owl Carousel-->
              <!-- <div class="owl-carousel-fullheight owl-nav-light owl-nav-position-variant-1 owl-nav-variant-1 owl-carousel" data-nav="true" data-items="1" data-mouse-drag="false">
                <div class="context-dark post-blog post-blog-type-3" style="background: url(../assets/images/post-32.jpg) right; background-size: cover;">
                  <div class="post-blog-caption">
                    <div class="row row-10 justify-content-end-xs-middle">
                      <div class="col-md-4 text-md-left"><a class="label label-primary" href="blog-classic.html">Photos</a></div>
                      <div class="col-md-8 text-md-right">
                        <p class="text-italic">September 7, 2019</p>
                      </div>
                    </div>
                    <h4 class="post-blog-title text-bold"><a href="blog-single-post.html">Visiting Paris on a Budget</a></h4>
                    <p>Paris is one of top-rated European cities – people  usually try to spend there as much time as possible, and you also may be lucky enough to spend an autumn house-sitting there. But even if you have somewhere to...</p><a class="post-blog-link" href="blog-single-post.html">Read more</a>
                  </div>
                </div>
                <div class="context-dark post-blog post-blog-type-3" style="background: url(&quot;../assets/images/post-06.jpg&quot;); background-size: cover;">
                  <div class="post-blog-caption">
                    <div class="row row-10 justify-content-end-xs-middle">
                      <div class="col-md-4 text-md-left"><a class="label label-primary" href="blog-classic.html">Article</a></div>
                      <div class="col-md-8 text-md-right">
                        <p class="text-italic">September 12, 2019</p>
                      </div>
                    </div>
                    <h4 class="post-blog-title text-bold"><a href="blog-single-post.html">How to Make Travel Videos</a></h4>
                    <p>Introducing our new Travel Video Course, taught by experts Sharon Carpenter and Beverly Bennett! They have over 31,000,000 YouTube views, have worked with big brands, tourism boards, and production...</p><a class="post-blog-link" href="blog-single-post.html">Read more</a>
                  </div>
                </div>
              </div> -->
              <div class="context-dark post-blog post-blog-type-3 postblog-img" style="
                    background-image: url('../assets/images/post-32.jpg');
                    background-size: cover;
                    background-position: right center;
                    background-repeat: no-repeat;height:100%;
                  ">
                  <div class="post-blog-caption">
                    <div class="row row-10 justify-content-end-xs-middle">
                      <div class="col-md-4 text-md-left"><a class="label label-primary">Photos</a></div>
                      <div class="col-md-8 text-md-right">
                        <p class="text-italic">September 7, 2019</p>
                      </div>
                    </div>
                    <h4 class="post-blog-title text-bold"><a>Visiting Paris on a Budget</a></h4>
                    <p>Paris is one of top-rated European cities – people  usually try to spend there as much time as possible, and you also may be lucky enough to spend an autumn house-sitting there. But even if you have somewhere to...</p><a class="post-blog-link">Read more</a>
                  </div>
                </div>
            </div>
            <div class="col-xl-6">
              <div class="row row-50 text-left">
                <div class="col-md-6 wow fadeInRight" data-wow-delay="0.4s">
                        <!-- Post type 2-->
                        <div class="post-blog post-blog-type-2"><img class="img-responsive" src="../assets/images/post-33.jpg" width="420" height="300" alt=""><a class="label label-primary">Article</a>
                          <div class="post-blog-caption">
                            <p class="text-italic text-gray">September 9, 2019</p>
                            <h4 class="post-blog-title text-bold"><a>9 Ways to Become a Successful Travel Blogger</a></h4>
                            <p class="text-base f-size-14">Travel blogging is a crowded field — and it gets more crowded day by day. And a lot of the advice that people give are actually counterintuitive to the...</p><a class="post-blog-link">Read more</a>
                          </div>
                        </div>
                </div>
                <div class="col-md-6 wow fadeInRight" data-wow-delay="0.5s">
                        <!-- Post type 2-->
                        <div class="post-blog post-blog-type-2"><img class="img-responsive" src="../assets/images/post-34.jpg" width="420" height="300" alt=""><a class="label label-primary">Article</a>
                          <div class="post-blog-caption">
                            <p class="text-italic text-gray">September 11, 2019</p>
                            <h4 class="post-blog-title text-bold"><a>The Ultimate Packing List For Female Travelers</a></h4>
                            <p class="text-base f-size-14">It can be daunting trying to figure out what to pack for a week, a month, or a year abroad without much — or any — prior experience in the place you want...</p><a class="post-blog-link">Read more</a>
                          </div>
                        </div>
                </div>
              </div>
            </div>
          </div>
          <div class="view-animate fadeInUpSmall delay-08"><a class="button button-primary button-naira button-naira-up"><span class="icon mdi mdi-arrow-right-bold"></span><span>View all blog posts</span></a></div>
        </div>
      </section>
      <section class="section-80 section-lg-40">
    <!-- Section Title -->
    <div class="container container-wide">
      <h5 class="text-info-dr">Hot Deals</h5>
      <h2 class="" style="margin-bottom:40px;">Popular Destinations</h2>
      <!-- <hr class="divider divider-primary divider-80" /> -->
    </div>

    <!-- Filter Navigation -->
    <div class="row row-60">
      <div class="col-12">
        <div class="filter-buttons">
          <ul class="nav-custom">
            <li
              v-for="filter in filters"
              :key="filter.value"
              @click="setFilter(filter.value)">
              <a :class="{ active: activeFilter === filter.value }">
                {{ filter.label }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Filtered Content -->
    <div class="row no-gutters">
      <div
        v-for="(destination, index) in filteredDestinations"
        :key="index"
        class="col-12 col-md-6 col-lg-4 p-0"
      >
        <a class="thumbnail-variant-4">
          <img
            class="img-responsive center-block thumbnail-image"
            :src="destination.image"
            :alt="destination.title" />
          <div class="caption">
            <h3 class="text-ubold">{{ destination.title }}</h3>
            <p>{{ destination.description }}</p>
            <div class="thumbnail-link"></div>
          </div>
        </a>
      </div>
    </div>

    <!-- Button -->
    <div class="button-wrap">
      <a class="button button-primary button-naira button-naira-up">
        <div class="icon fa-search"></div>
        <span>Find Tickets</span>
      </a>
    </div>
  </section>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { getConfigDataFromLocalStorage } from "@/localStorageData/localStorageUtil.js";
export default {
  components:{
    VueDatePicker
  },
  data() {
    return {
      activeFilter: "*",
      model:null,
      radios:"round",
      activeTab:'flights',
      countries: [{ name: "Australia", code: "AU" }],
      filters: [
        { label: "All Offers", value: "*" },
        { label: "Europe", value: "Type 1" },
        { label: "North America", value: "Type 2" },
        { label: "Asia", value: "Type 3" },
        { label: "Australia", value: "Type 4" },
      ],
      destinations: [
        {
          title: "Barcelona",
          description: "The cultural, commercial, and financial center of Northern California.",
          image: require('../assets/images/post-35.jpg'),
          type: "Type 1",
        },
        {
          title: "London",
          description: "The cultural, commercial, and financial center of Northern California.",
          image: require("../assets/images/post-36.jpg"),
          type: "Type 2",
        },
        {
          title: "New York",
          description: "The cultural, commercial, and financial center of Northern California.",
          image: require("../assets/images/post-37.jpg"),
          type: "Type 3",
        },
        {
          title: "Rome",
          description: "The cultural, commercial, and financial center of Northern California.",
          image: require("../assets/images/post-38.jpg"),
          type: "Type 4",
        },
        {
          title: "Paris",
          description: "The cultural, commercial, and financial center of Northern California.",
          image: require("../assets/images/post-39.jpg"),
          type: "Type 1",
        },
        {
          title: "Phuket",
          description: "The cultural, commercial, and financial center of Northern California.",
          image: require("../assets/images/post-43.jpg"),
          type: "Type 2",
        },
        // Add more destinations here...
      ],
      carousels:[
        {
          img: require("../assets/images/logo-14.png")
        },
        {
          img: require("../assets/images/logo-15.png")
        },
        {
          img: require("../assets/images/logo-16.png")
        },
        {
          img: require("../assets/images/logo-17.png")
        },
        {
          img: require("../assets/images/logo-18.png")
        },
        {
          img: require("../assets/images/logo-19.png")
        }
      ],
      inputCity: "",
      inputCityto: "",
      typedrop: false,
      typedrop1: false,
      subscribeApi: "",
      fromloader: false,
      toloader: false,
      fromlabel: false,
      tolabel: false,
      loader: false,
      dialog1: false,
      dialog2: false,
      dateFormat: "MMM dd",
      sixWeekMode: true,
      classSelect: false,
      subPhonenumber: "",
      multiCalender: true,
      selectedCountry: "",
      maximumletter: false,
      maximumletter1: false,
      fromDate: "",
      name1: "John Doe",
      source: "vasanth",
      trav: true,
      loginbox: false,
      registerbox: false,
      terms: false,
      visible: false,
      RecentSearchData: [],
      red: "1",
      red1: 1,
      rount: true,
      Oneway: false,
      multicity: false,
      // select: "Economy",
      travels: false,
      aduls: 1,
      aduls1: 0,
      aduls2: 0,
      resultData: 1,
      classType: "Economy",
      addition: 0,
      customer: [],
      buton: true,
      avath: false,
      error: false,
      viewbox: false,
      isVisible: true,
      // selectAirports: "",
      token: "Tc7RQaX79Hrx5CFK",

      // Autocomplete
      loading: false,
      fromAirports: [],
      airitems: [],
      // Autocomplete End

      items: [],

      clicked1: false,
      clicked2: false,
      clicked3: false,
      datePickerIsOpen: false,

      fromErrorMessage: false,
      toErrorMessage: false,
      fromDateError: false,
      toDateError: false,

      disButton: false,
      loadSearch: false,
      valid: false,
      Errormsg: "",
      agreeMsg: "",
      subscribe: {
        email: "",
        phone: "",
        checkAgree: false,
      },

      roundedShadow: false,
      emailBox: false,
      phoneNumber: true,

      subEmailvalid: [
        (v) => !!v || "This field is required",
        (v) => /.+@.+\..+/.test(v) || "Please enter a valid email address",
      ],
      phoneValidate: [
        (v) => /^\+?[0-9]{1,16}$/.test(v) || "Please enter a phone number ",
        // (v) => /^(\+?[0-9]{1,12})?$/.test(v) || "Please enter a valid phone number (up to 12 digits, starting with +)",
      ],
      classTypeitems:[
        {
          value: "Economy",
          department: "Economy Department",
        },
        {
          value: "Business",
          department: "Business Department",
        },
        {
          value: "First Class",
          department: "First Class Department",
        },
        {
          value: "Premium Economy",
          department: "Premium Economy Department",
        },
      ],

      input: [
        {
          from: null,
          to: null,
          departDate: null,
          multiFromError: false,
          multiToError: false,
          multiDateError: false,
        },
        {
          from: null,
          to: null,
          departDate: null,
          multiFromError: false,
          multiToError: false,
          multiDateError: false,
        },
      ],

      addmore: true,
      clearall: false,

      airbooking: true,
      mytrips: false,
      resentSearch: false,

      oneway: {
        from: null,
        to: null,
        travelDate: null,
        dedate: null,
        redate: null,
        class: "",
        child: "",
        adult: "",
        infrant: "",
        city: "",
        directflight:false,
      },
      city: [],
      city1: [],
      multiData: {
        itinery: [
          {
            from: null,
            to: null,
            departDate: null,
            multiFromError: false,
            multiToError: false,
            multiDateError: false,
            maximumletter: false,
            maximumletter1: false,
            clicked3: false,
            multiSearchBtn: true,
            focusMultiEvent1: false,
            focusMultiEvent2: false,
            focusMultiEvent3: false,
            autocomfrom: false,
            autocomTo: false,
            autocomFromDrop: false,
            autocomToDrop: false,
            selectedFrom: false,
            selectedTo: false,
          },
          {
            from: null,
            to: null,
            departDate: null,
            multiFromError: false,
            multiToError: false,
            multiDateError: false,
            maximumletter1: false,
            clicked3: false,
            multiSearchBtn: true,
            focusMultiEvent1: false,
            focusMultiEvent2: false,
            focusMultiEvent3: false,
            autocomfrom: false,
            autocomTo: false,
            autocomFromDrop: false,
            autocomToDrop: false,
            selectedFrom: false,
            selectedTo: false,
          },
        ],
        class: "",
        child: "",
        adult: "",
        infrant: "",
        city: "3",
      },
      multidrop: [],
      multidrop1: [],
      onewaydata: {
        request_type: "air_search",
        request: {
          AirShoppingRQ: {
            CoreQuery: {
              OriginDestinations: {
                OriginDestination: [
                  {
                    Departure: {
                      AirportCode: "MAA",
                      Date: "2023-10-19",
                    },
                    Arrival: {
                      AirportCode: "BOM",
                    },
                  },
                ],
              },
            },
            DataLists: {
              PassengerList: {
                Passenger: [
                  {
                    PassengerID: "T1",
                    PTC: "ADT",
                  },
                ],
              },
            },
            Preference: {
              TripType: "",
              CabinType: "",
              Currency: "",
              FareType: [],
            },
            MetaData: {
              Currency: "USD",
            },
          },
        },
        country: "",
        token: "Tc7RQaX79Hrx5CFK",
      },

      Rountdata: {
        request_type: "air_search",
        request: {
          AirShoppingRQ: {
            CoreQuery: {
              OriginDestinations: {
                OriginDestination: [
                  {
                    Departure: {
                      AirportCode: "MAA",
                      Date: "2023-08-25",
                    },
                    Arrival: {
                      AirportCode: "BOM",
                    },
                  },
                  {
                    Departure: {
                      AirportCode: "BOM",
                      Date: "2023-10-27",
                    },
                    Arrival: {
                      AirportCode: "MAA",
                    },
                  },
                ],
              },
            },
            DataLists: {
              PassengerList: {
                Passenger: [
                  {
                    PassengerID: "T1",
                    PTC: "ADT",
                  },
                ],
              },
            },
            Preference: {
              TripType: "",
              CabinType: "",
              Currency: "",
              FareType: [],
            },
            MetaData: {
              Currency: "USD",
            },
          },
        },
        country: "",
        token: "Tc7RQaX79Hrx5CFK",
      },

      Adult: [],
      Child: [],
      recendFrom: [],
      recendTo: [],
      resultFrom: [],
      resultTo: [],
      forData: false,
      formres: false,
      formres1: false,
      Infrant: [],
      urldedate: "",
      urlredate: "",
      roundfrom: "",
      roundto: "",
      concatenatedArray: [],
      loadingData: true,
      dataloaded: false,
      randomAlphabets: "",
      cacheData: "",
      fromRecent: "",
      toRecent: "",
      multi: {
        from: null,
        to: null,
      },
      getLangname:"",
      popularDestinationApi:"",
      airlineCarouselApi:"",
      whyChooseApi:"",
      whyChoose : [],
      directflight1:false,
      directflight:false,
    };
  },
  computed: {
    filteredDestinations() {
      if (this.activeFilter === "*") {
        return this.destinations;
      } else {
        return this.destinations.filter(
          (destination) => destination.type === this.activeFilter
        );
      }
    },
     filteredCountries() {
      return this.airitems.map((item) => {
        const parts = item.places.split(", ");
        if (parts.length >= 2) {
          const name = `${parts[1]} (${parts[0]})`;
          // const name = `${parts[0]} - ${parts[1]}`;
          const originalName = item.places;
          return {
            name,
            originalName,
          };
        }
      });
    },
  },
  methods: {
    setFilter(filter) {
      this.activeFilter = filter;
    },
    setActiveTab(tab) {
      this.activeTab = tab;
    },
    selectClasstype(item) {
      this.classType = item.value;
    },
    cardassigndata($event) {
      console.log($event, "$event4444");
      this.resentSearch = false;
      this.activeTab = 'flights';
      this.oneway.from = $event.from;
      this.oneway.to = $event.to;
      this.selectedFrom = true;
      this.selectedTo = true;
      this.aduls = $event.adult;
      this.aduls1 = $event.child;
      this.aduls2 = $event.inf;
      this.classType = $event.class;
      this.oneway.dedate = $event.fromDate;
      this.oneway.redate = $event.toDate;

      this.act($event.city);
      // this.updateRecentSearch($event)

      if ($event.itinery) {
        console.log($event, "$event1111111");
        this.aduls = $event.adult;
        this.aduls1 = $event.child;
        this.aduls2 = $event.infrant;

        this.multiData = {
          adult: $event.adult,
          child: $event.child,
          infrant: $event.infrant,
          class: $event.class,
          city: $event.city,
          itinery: $event.itinery.map((itin) => ({
            ...itin,
            departDate: itin.departDate,
            selectedFrom: true,
            selectedTo: true,
          })),
        };

        this.handleMultiSearch(this.multiData);

        console.log(this.multiData, "this.multiData..11");
      } else {
        this.handleRecentSearch($event);
      }
    },
    recentFromData() {
      let result1 = JSON.parse(localStorage.getItem("recentFrom")) || [];
      let today = new Date();

      const filteredResults = result1.filter((item) => {
        if (item.itinery && item.itinery.length > 0) {
          for (let itineraryItem of item.itinery) {
            let depDate = new Date(itineraryItem.departDate);
            if (depDate < today) {
              return false;
            }
          }
        } else {
          let fromDate = new Date(item.fromDate);
          if (fromDate < today) {
            return false;
          }
        }
        return true;
      });

      localStorage.setItem("recentFrom", JSON.stringify(filteredResults));

      this.RecentSearchData = filteredResults.slice(0, 8);
    },
    getdated($event) {
      return moment($event).format(" DD-MMM-YYYY");
    },
     handleMultiSearch(newMultiData) {
      let storedRecentFrom =
        JSON.parse(localStorage.getItem("recentFrom")) || [];

      storedRecentFrom = storedRecentFrom.filter((existingItem) => {
        const existingItinery = existingItem.itinery || [];

        const isDuplicate = newMultiData.itinery.every((newItin) =>
          existingItinery.some(
            (existingItin) =>
              newItin.from === existingItin.from &&
              newItin.to === existingItin.to &&
              newItin.depdata === existingItin.depdata
          )
        );

        const isAdditionalPropsMatch =
          existingItem.adult === newMultiData.adult &&
          existingItem.child === newMultiData.child &&
          existingItem.infrant === newMultiData.infrant &&
          existingItem.class === newMultiData.class &&
          existingItem.city === newMultiData.city;

        return !(isDuplicate && isAdditionalPropsMatch);
      });

      storedRecentFrom.unshift(newMultiData);

      // localStorage.setItem("recentFrom", JSON.stringify(storedRecentFrom));
      return storedRecentFrom;
    },

    handleRecentSearch(data) {
      let recentSearchObj;

      let isOneway = this.oneway.city == "2" ? true : false;

      if (data) {
        recentSearchObj = {
          from: data.from || "",
          to: data.to || "",
          fromDate: data.fromDate || "",
          toDate: isOneway ? null : data.toDate || null,
          adult: data.adult || 0,
          child: data.child || 0,
          inf: data.inf || 0,
          city: data.city || "",
          class: data.class || "",
        };
        console.log("Using provided data:", recentSearchObj);
      } else {
        recentSearchObj = {
          from: this.oneway.from || "",
          to: this.oneway.to || "",
          fromDate: this.oneway.dedate || "",
          toDate: isOneway ? null : this.oneway.redate || null,
          adult: this.aduls || 0,
          child: this.aduls1 || 0,
          inf: this.aduls2 || 0,
          city: this.red1 || "",
          class: this.classType || "",
        };
        console.log("Using current state values:", recentSearchObj);
      }

      let storedRecentFrom =
        JSON.parse(localStorage.getItem("recentFrom")) || [];
      console.log("Stored recent searches:", storedRecentFrom);

      storedRecentFrom = storedRecentFrom.filter((search) => {
        const searchFromDate = new Date(search.fromDate).toDateString();
        const searchToDate = new Date(search.toDate).toDateString();
        const recentFromDate = new Date(
          recentSearchObj.fromDate
        ).toDateString();
        const recentToDate = new Date(recentSearchObj.toDate).toDateString();

        return !(
          search.from === recentSearchObj.from &&
          search.to === recentSearchObj.to &&
          searchFromDate === recentFromDate &&
          searchToDate === recentToDate &&
          search.adult === recentSearchObj.adult &&
          search.child === recentSearchObj.child &&
          search.inf === recentSearchObj.inf &&
          search.city === recentSearchObj.city &&
          search.class === recentSearchObj.class
        );
      });

      storedRecentFrom.unshift(recentSearchObj);
      console.log("Updated search list:", storedRecentFrom);

      // localStorage.setItem("recentFrom", JSON.stringify(storedRecentFrom));
      return storedRecentFrom;
    },

     closeDropdown() {
      this.travels = false;
      this.$refs.countrySelect.blur();
      // this.$refs.mySelect.blur();
    },
    act(data) {
      this.red1 = data;
      console.log(this.red1, '00')
      this.oneway.city = this.red1;
      if (this.red1 == 2) {
        this.Oneway = true;
        (this.rount = false), (this.multicity = false);
        this.radios = "oneway";
      }
      if (data == 1) {
        this.Oneway = false;
        this.rount = true;
        this.multicity = false;
        this.radios = "round";
      }
      if (data == 3) {
        this.Oneway = false;
        this.rount = false;
        this.multicity = true;
        this.radios = "multicity";
      }
    },
    async typeCity(event, $data) {
      if (event.length < 3 && $data == 1) {
        this.maximumletter = true;
      } else {
        this.maximumletter = false;
      }
      if (event.length < 3 && $data == 2) {
        this.maximumletter1 = true;
      } else {
        this.maximumletter1 = false;
      }
      if (event.length >= 1) {
        this.formres = false;
        if (event.length >= 1) {
          this.formres1 = false;
        }
      }
      this.city = [];
      this.city1 = [];
      // let $event = [];
      console.log(event, $data, "searchsearchsearchsearch");
      if ($data == 1 && event.length > 0) {
        this.fromloader = true;
      } else {
        this.fromloader = false;
      }

      if ($data == 2 && event.length > 0) {
        this.toloader = true;
      } else {
        this.toloader = false;
      }

      if (event.length >= 3) {
        await axios
          .get(`${this.autocompleteApi}?airportString=${event}`, {
            headers: {
              "Content-Type": this.airlineIcaoType,
            },
          })
          .then((response) => {
            console.log(response, response.data, "responseyyyyyyy");

            if ($data == 1) {
              this.fromloader = false;
              this.city = response.data;
              this.typedrop = true;
            } else if ($data == 2) {
              this.toloader = false;
              this.city1 = response.data;
              this.typedrop1 = true;
            }
          })
          .catch((error) => {
            console.log(error, "erroroor.....");
          });

        this.maximumletter = false;
        this.maximumletter1 = false;
        this.loading = true;
      }
    },
    onChangeFrom() {
      setTimeout(() => {
        if (this.oneway.from) {
          console.log(this.oneway.from, this.inputCity, "errorMessage...1");
          this.fromErrorMessage = false;
          this.changeTextFrom = true;
        }
      }, 50);

      setTimeout(() => {
        if (!this.oneway.from) {
          console.log("errorMessage...2");
          this.fromErrorMessage = true;
        }
      }, 100);
    },

    onChangeTo() {
      setTimeout(() => {
        if (this.oneway.to) {
          this.toErrorMessage = false;
          this.changeTextTo = true;
        }
      }, 50);

      setTimeout(() => {
        if (!this.oneway.to) {
          this.toErrorMessage = true;
        }
      }, 100);
    },
     fromInputData() {
      this.oneway.from = "";
      if (!this.oneway.from) {
        this.selectedFrom = false;
        this.$refs.fromAutoComplete.focus();
      }
    },
    toInputData() {
      this.oneway.to = "";
      if (!this.oneway.to) {
        this.selectedTo = false;
        this.$refs.toAutoComplete.focus();
      }
    },

    multiDateChanged(newValue, index) {

      this.multiData.itinery.map((v, i) => {
        if (index == i) {
          if (v.departDate) {
            const inputElement = this.$refs.multiToAutocomplete[index + 1];
            if (inputElement) {
              inputElement.focus();
            }
          } else {
            const inputElement = this.$refs.dpRef4[index];
            if (inputElement) {
              inputElement.openMenu();
            }
          }
        }
      });

      this.multiData.itinery[index].departDate = newValue;
      if (newValue) {
        this.multiData.itinery[index].multiDateError = false;
        this.multiData.itinery[index].focusMultiEvent3 = false;
      } else {
        this.multiData.itinery[index].multiDateError = true;
        this.multiData.itinery[index].focusMultiEvent3 = true;
      }

      console.log(
        this.multiData.itinery[index],
        `Updated itinerary at index ${index}`
      );

      this.multiData.itinery.forEach((v, i) => {
        if (index < i) {
          if (newValue > new Date(v.depdata)) {
            v.depdata = null;
          }
        }
      });
    },
    datachange(data) {
      console.log(data, "pppp");
      this.oneway.from = `${data.city} (${data.iata})`;
      // this.inputCity = this.oneway.from;
      this.typedrop = false;
      const regex = /[-()]/;
      if (regex.test(this.oneway.from)) {
        this.selectedFrom = true;
      }
      if (!this.oneway.to) {
        this.$refs.toAutoComplete.focus();
      } else {
        this.$refs.fromAutoComplete.focus();
      }
    },
    datachangeTo(data) {
      this.oneway.to = `${data.city} (${data.iata})`;
      // this.inputCityto = this.oneway.to;
      this.typedrop1 = false;
      const regex = /[-()]/;
      if (regex.test(this.oneway.to)) {
        this.selectedTo = true;
      }
      if (!this.oneway.dedate) {
        this.$refs.dpRef1.openMenu();
      } else {
        this.$refs.toAutoComplete.focus();
      }
    },
    clickFocus() {
      const regex = /[-()]/;
      if (!regex.test(this.oneway.from)) {
        this.$refs.fromAutoComplete.focus();
      }
    },
    clickFocusTo() {
      const regex = /[-()]/;
      if (!regex.test(this.oneway.to)) {
        this.$refs.toAutoComplete.focus();
      }
    },
    deg1() {
      this.adulted1();
      if (this.aduls == this.aduls2 && this.aduls2 > 1) {
        this.deg3();
      }
      if (this.aduls > 1) {
        this.aduls = this.aduls - 1;
        this.added();
      }
    },
    add1() {
      if (this.aduls < 9 && this.addition < 9) {
        this.aduls += 1;
        this.adulted();
        this.added();
      }
    },

    deg2() {
      if (this.aduls1 > 0) {
        this.aduls1 = this.aduls1 - 1;
        this.Childed1();
        this.added();
      }
    },
    add2() {
      if (this.aduls1 < 8 && this.addition < 9) {
        this.aduls1 = this.aduls1 + 1;
        this.Childed();
        this.added();
      }
    },
    deg3() {
      if (this.aduls2 > 0) {
        this.aduls2 = this.aduls2 - 1;
        this.Infranted1();
        this.added();
      }
    },
    add3() {
      if (this.addition < 9 && this.aduls > this.aduls2) {
        this.aduls2 = this.aduls2 + 1;
        this.Infranted();
        this.added();
      }
    },

    added() {
      this.addition = this.aduls + this.aduls1 + this.aduls2;
      this.concatenatedArray = this.Adult.concat(this.Child).concat(
        this.Infrant
      );
      this.passengerData();
    },
    passengerData() {
      this.resultData = this.aduls + this.aduls1 + this.aduls2;
    },
    adulted() {
      this.Adult.push({
        PassengerID: "T",
        PTC: "ADT",
      });
    },
    adulted1() {
      this.Adult.pop();
    },

    Childed() {
      this.Child.push({
        PassengerID: "T",
        PTC: "CHD",
      });
    },
    Childed1() {
      this.Child.pop();
    },
    Infranted() {
      this.Infrant.push({
        PassengerID: "T",
        PTC: "INF",
      });
      this.passengerData();
    },
    Infranted1() {
      this.Infrant.pop();
    },
    localdone() {
      localStorage.setItem("value1", "this.aduls");
      this.travels = false;
    },
    clickMultiFrom(index) {
      this.multiData.itinery.map((v, i) => {
        if (i == index) {
          const regex = /[-()]/;
          if (!regex.test(v.from)) {
            this.$refs.multiFromAutocomplete[index].focus();
          }
        }
      });
    },
    clickMultiTo(index) {
      this.multiData.itinery.map((v, i) => {
        if (i == index) {
          const regex = /[-()]/;
          if (!regex.test(v.to)) {
            this.$refs.multiToAutocomplete[index].focus();
          }
        }
      });
    },
     async typeMultiCity(event, index, $num) {
      console.log(event, index, $num, "searchsearchsearchsearch");
      // let $event = [];
      console.log(event, index, "searchsearchsearchsearch");

      if (event.length >= 3) {
        if ($num == 1 && event.length > 2) {
          this.multiData.itinery.map((v, i) => {
            v.autocomTo = false;
            v.fromloader = true;
            if (i == index && event.length > 2) {
              v.autocomfrom = true;
            } else {
              v.autocomfrom = false;
              v.fromloader = false;
              this.multidrop = [];
            }
          });
        } else if ($num == 2 && event.length > 0) {
          this.multiData.itinery.map((v, i) => {
            v.autocomfrom = false;
            if (i == index && event.length > 2) {
              v.autocomTo = true;
              v.toloader = true;
            } else {
              v.autocomTo = false;
              v.toloader = false;
              this.multidrop1 = [];
            }
          });

          // for (let i = 1; i < this.multiData.itinery.length; i++) {
          //   this.multiData.itinery[i].from = this.multiData.itinery[i - 1].to;
          // }
        }

        await axios
          .get(`${this.autocompleteApi}?airportString=${event}`, {
            headers: {
              "Content-Type": this.airlineIcaoType,
            },
          })
          .then((response) => {
            console.log(response.data, "responsedata");

            if ($num == 1) {
              this.multiData.itinery.map((v) => {
                v.fromloader = false;
              });

              this.multidrop = response.data;
              console.log(this.multidrop, "this.multidrop");
            } else if ($num == 2) {
              this.multiData.itinery.map((v) => {
                v.toloader = false;
              });

              this.multidrop1 = response.data;
            }
          })

          .catch((error) => {
            console.log(error, "erroroor.....");
          });

        this.maximumletter = false;
        this.maximumletter1 = false;
        this.loading = true;
      }
    },
    multiFrom(index) {
      //   const regex = /[-()]/;
      this.multiData.itinery.map((v, i) => {
        if (i == index) {
          v.from = "";
          v.selectedFrom = false;
          this.$refs.multiFromAutocomplete[index].focus();
        }
        //   else if(regex.test(v.from)){
        //     v.selectedFrom = true
        // }
      });
    },
    multiTo(index) {
      //   const regex = /[-()]/;
      this.multiData.itinery.map((v, i) => {
        if (i == index) {
          v.to = "";
          v.selectedTo = false;
          this.$refs.multiToAutocomplete[index].focus();
        }
        //   else if(regex.test(v.from)){
        //     v.selectedTo = true
        // }
      });
    },
    datachangeMuti(data, index) {
      console.log(data, index, "data,index1");
      this.multiData.itinery.map((v, i) => {
        if (i == index) {
          v.from = `${data.city} (${data.iata})`;
          v.autocomfrom = false;
          v.multiFromError = false;
          v.selectedFrom = true;
          //   if(!v.from){
          //     this.$refs.multiFromAutocomplete[index].focus()
          //   }
          if (!v.to) {
            const inputElement = this.$refs.multiToAutocomplete[index];
            if (inputElement) {
              inputElement.focus();
            }
          } else if (v.from) {
            const inputElement = this.$refs.multiFromAutocomplete[index];
            console.log(this.$refs.fromAutoComplete);
            if (inputElement) {
              inputElement.blur();
            }
          }
        }
      });
      console.log(this.multiData, "this.multiDatathis.multiData");
    },
    datachangeMutiTo(data, index) {
      console.log(data, index, "data,index1");
      this.multiData.itinery.map((v, i) => {
        if (i == index) {
          v.to = `${data.city} (${data.iata})`;
          v.autocomTo = false;
          v.multiToError = false;
          v.selectedTo = true;
          if (!v.to) {
            this.$refs.multiToAutocomplete[index].focus();
          }
          if (!v.departDate) {
            const inputElement = this.$refs.dpRef4[index];
            if (inputElement) {
              inputElement.openMenu();
            } else {
              const inputElement = this.$refs.multiFromAutocomplete[index];
              if (inputElement) {
                inputElement.blur();
              }
            }
          }
          if (this.multiData.itinery.length - 1 != index) {
            this.multiData.itinery[i + 1].from = this.multiData.itinery[i].to;
            this.multiData.itinery[i + 1].multiFromError = false;
            this.multiData.itinery[i + 1].selectedFrom = true;
          }
        }
      });
      console.log(this.multiData, "this.multiDatathis.multiData");
    },
    getdate1($data, index) {
      if (index > 0) {
        return $data[index - 1].departDate;
      } else {
        return `${new Date()}`;
      }
    },
    addTrip() {
      if (this.multiData.itinery.length < 4) {
        this.multiData.itinery.push({
          from: null,
          to: null,
          departDate: null,
          multiFromError: false,
          multiToError: false,
          multiDateError: false,
          multiSearchBtn: true,
          focusMultiEvent1: false,
          focusMultiEvent2: false,
          focusMultiEvent3: false,
        });

        if (this.multiData.itinery.length == 4) {
          this.addmore = false;
        }
      }
      if (this.multiData.itinery.length > 3) {
        this.clearall = true;
      }

      this.multiData.itinery.map((v, i) => {

        if (this.multiData.itinery.length - 2 == i) {
          this.multiData.itinery[i + 1].from = this.multiData.itinery[i].to;
          if (this.multiData.itinery[i + 1].from != null) {
            this.multiData.itinery[i + 1].selectedFrom = true;
          }
        }
      });
    },

    clearall1() {
      this.multiData.itinery.splice(2, 5);
      (this.multiData.itinery = [
        {
          from: null,
          to: null,
          departDate: null,
          multiFromError: false,
          multiToError: false,
          multiDateError: false,
          maximumletter: false,
          maximumletter1: false,
          clicked3: false,
        },
        {
          from: null,
          to: null,
          departDate: null,
          multiFromError: false,
          multiToError: false,
          multiDateError: false,
          maximumletter1: false,
          clicked3: false,
        },
      ]),
        (this.clearall = false);
      this.addmore = true;
    },
    deleteItin(index) {
      this.multiData.itinery.splice(index, 1);
    },
    fromDateChanged(newValue) {
      this.oneway.dedate = newValue;
      this.oneway.dedate = new Date(this.oneway.dedate)
      this.oneway.redate = new Date(this.oneway.redate)

      if (this.rount && this.oneway.dedate) {
        if (this.oneway.redate && this.oneway.redate < this.oneway.dedate) {
          this.oneway.redate = null;
        }

        this.clicked1 = true;
        this.fromDateError = false;

        this.$refs.dpRef2.openMenu();
        // this.focusedElement = "calendar2";

      } else if(!this.oneway.dedate) {
        this.clicked1 = false;
        this.fromDateError = true;

        this.$refs.dpRef1.openMenu();
      }
      if (this.rount && !this.oneway.redate) {
        // console.log(this.rount, 'key')
        this.$refs.dpRef2.openMenu();
      } else {
        this.$refs.dpRef1.openMenu();
      }
    },
    toDateChanged(newValue) {
      this.oneway.redate = newValue;
      // this.$refs.dpRef2.openMenu();
      // this.focusedElement = "calendar2";

      if (this.oneway.redate) {
        this.clicked1 = true;
        this.toDateError = false;
      } else {
        this.clicked1 = false;
        this.toDateError = true;
        this.$refs.dpRef2.openMenu();
      }
    },
    ClickOutReturn() {
      this.$refs.dpRef2.closeMenu();
      if (this.oneway.redate) {
        this.clicked2 = true;
      } else {
        this.clicked2 = false;
      }
    },

    // clearDate() {
    //   this.oneway.dedate = null;
    //   this.oneway.travelDate = null;
    //   this.focusEvent3 = false;
    // },
    clearDate(tripdate, type) {
      console.log(tripdate, 'tripdatetripdate');
      if (type === 'dep') {
        this.oneway.dedate = null;
        this.oneway.travelDate = null;
        this.focusEvent3 = false;
      }
      else {
        this.oneway.redate = null;
      }
    },

    ClickOutDepat() {
      this.$refs.dpRef1.closeMenu();
      // console.log(v.clicked3,"checking....")

      if (this.oneway.dedate) {
        this.clicked1 = true;
        // this.fromlabel=true
      } else {
        this.clicked1 = false;
        // this.fromlabel=false;
      }
    },
    sended() {
      this.focusFalse = false;
      console.log(this.focusEvent3, "focusEvent3focusEvent3");

      this.$nextTick(() => {
        this.focusEvent3 = false;
        this.$refs.dpRef1.closeMenu();
        console.log(this.focusEvent3, "this.focusEvent3this.focusEvent3");
      });

      localStorage.removeItem("rounttrip");
      localStorage.removeItem("onewaytrip");
      // console.log(this.oneway, 'oneway.classoneway.class')

      console.log(this.activeAdvanceSearch,'sdasdactiveAdvanceSearch...1')
      if(this.activeAdvanceSearch) this.dataAssign();

      let returnDate = this.Oneway ? true : this.oneway.redate;
      console.log(this.oneway,'onewayonrounttripewayoneway...1');

      if (this.oneway.from && this.oneway.to && this.oneway.dedate && returnDate && (this.oneway.from !== this.oneway.to)) {
        setTimeout(() => {
          // this.$refs.dpRef1.closeMenu();
          this.focusEvent3 = false;
          // console.log(this.$refs.dpRef1, 'fdfdfdfdfdf...1')
        }, 5);

        this.urldedate = moment(this.oneway.dedate).format("YYYY/MM/DD");
        this.urlredate = moment(this.oneway.redate).format("YYYY/MM/DD");

        this.oneway.city = this.red1;
        this.oneway.adult = this.aduls;
        this.oneway.infrant = this.aduls2;
        this.oneway.child = this.aduls1;
        this.oneway.class = this.classType;
        this.oneway.directflight = this.directflight;
        let result1 = [];
        result1 = JSON.stringify(this.oneway);
        localStorage.setItem("rountData", result1);

        if (this.oneway.from.name) {
          this.roundfrom = this.oneway.from.name;
        } else {
          this.roundfrom = this.oneway.from;
        }

        if (this.oneway.to.name) {
          this.roundto = this.oneway.to.name;
        } else {
          this.roundto = this.oneway.to;
        }

        let rountdetail = {
          from: this.roundfrom,
          to: this.roundto,
          dedate: this.urldedate,
          redate: this.urlredate,
          class: this.oneway.class,
          child: this.oneway.child,
          adult: this.oneway.adult,
          infrant: this.oneway.infrant,
          city: this.oneway.city,
          directFlight: this.directflight,
        };
        console.log(rountdetail, "rountdetailrountdetail");

        const tabId = sessionStorage.getItem("tabId") || Date.now().toString();
        sessionStorage.setItem("tabId", tabId);

        const result = JSON.stringify(rountdetail);
        console.log(result,'sdasdaresult1')

         if(this.oneway.redate){
            localStorage.setItem(`searchedData-round-${tabId}`, result1);
        }
        else{
            localStorage.setItem(`searchedData-oneway-${tabId}`, result1);
        }
  
        this.searchCase = this.oneway;
        console.log(this.searchCase,'ssdasdseasaaSrchCase...5')

        let fromCode = rountdetail.from.match(/\(([^)]+)\)/)[1];
        let toCode = rountdetail.to.match(/\(([^)]+)\)/)[1];


        let tripType = "";
        let itinerary = "";
        if (rountdetail.city == 1) {
          tripType = "RT";
          itinerary = `${fromCode}-${toCode}-${rountdetail.dedate}_${toCode}-${fromCode}-${rountdetail.redate}`;
        }
        else if(rountdetail.city == 2){
          tripType = "OW";
          itinerary = `${fromCode}-${toCode}-${rountdetail.dedate}`
        }

        let paxType = `A-${rountdetail.adult}_C-${rountdetail.child}_I-${rountdetail.infrant}`;

        let cabin = rountdetail.class;

        if (this.oneway.class == "Economy") {
          cabin = "Economy";
        }
        if (this.oneway.class == "Business") {
          cabin = "Business";
        }
        if (this.oneway.class == "First Class") {
          cabin = "FirstClass";
        }
        if (this.oneway.class == "Premium Economy") {
          cabin = "PremiumEconomy";
        }

        let query = `itinerary=${itinerary}&tripType=${tripType}&paxType=${paxType}&cabin=${cabin}`;

        console.log(query, "Formatted Query");

        const resultData = this.handleRecentSearch();

        localStorage.setItem("recentFrom", JSON.stringify(resultData));

        // this.$router.push({ path: "/flight/search", query: rountdetail });
        this.$router.push({
          path: "/flight/search",
          query: { itinerary, tripType, paxType, cabin },
        });
      } else {
        // alert("Please Enter the Details");
        this.validateOnewayForm();
      }
    },
    validateRountData() {
      const regex = /[-()]/;
      let fromData = this.oneway.from;
      let toData = this.oneway.to;

      const fromInvalid = fromData != null && regex.test(fromData);
      const toInvalid = toData != null && regex.test(toData);
      const dedateInvalid = this.oneway.dedate != null;
      const redateInvalid = this.oneway.redate != null;

      if (fromInvalid && toInvalid && dedateInvalid && redateInvalid) {
        return true;
      }

      return false;
    },
    validateOnewayForm() {
      const regex = /[-()]/;
      if (this.oneway.from && regex.test(this.oneway.from)) {
        this.fromErrorMessage = false;
      } else {
        this.oneway.from = "";
        this.fromErrorMessage = true;
      }

      if (this.oneway.to && regex.test(this.oneway.to)) {
        this.toErrorMessage = false;
      } else {
        this.oneway.to = "";
        this.toErrorMessage = true;
      }

      if (this.oneway.dedate) {
        this.fromDateError = false;
      } else {
        this.fromDateError = true;
      }

      if (this.oneway.redate) {
        this.toDateError = false;
      } else if (!this.oneway.redate && this.rount == true) {
        this.toDateError = true;
      }
    },
    validateItinerary() {
      const regex = /[-()]/;
      let isValid = true;

      for (let i = 0; i < this.multiData.itinery.length; i++) {
        const itinerary = this.multiData.itinery[i];

        const fromInvalid =
          itinerary.from !== null || regex.test(itinerary.from);
        const toInvalid = itinerary.to !== null || regex.test(itinerary.to);
        const departDateInvalid = itinerary.departDate !== null;

        console.log(
          `Itinerary ${i}: fromInvalid=${fromInvalid}, toInvalid=${toInvalid}, departDateInvalid=${departDateInvalid}`
        );

        if (fromInvalid || toInvalid || departDateInvalid) {
          isValid = false;
        }
      }

      return isValid;
    },
     sendedMulticity() {
      
      //  console.log(this.activeAdvanceSearch,'sdasdactiveAdvanceSearch...2')
      //  let data = this.activeAdvanceSearch()
      // if(data) this.dataAssign();

      this.focusFalse = false;
      console.log(this.multiData, " this.multiData this.multiData");
      let validateData = this.validateItinerary();
      console.log(validateData, "validateMultiCityyyy");

      if (
        this.multiData.itinery[0].from &&
        this.multiData.itinery[0].to &&
        this.multiData.itinery[0].departDate &&
        this.multiData.itinery[1].from &&
        this.multiData.itinery[1].to &&
        this.multiData.itinery[1].departDate &&
        (!this.multiData.itinery[2] ||
          (this.multiData.itinery[2].from &&
            this.multiData.itinery[2].to &&
            this.multiData.itinery[2].departDate)) &&
        (!this.multiData.itinery[3] ||
          (this.multiData.itinery[3].from &&
            this.multiData.itinery[3].to &&
            this.multiData.itinery[3].departDate))
      ) {
        this.multiData.adult = this.aduls;
        this.multiData.child = this.aduls1;
        this.multiData.infrant = this.aduls2;
        this.multiData.class = this.classType;

        const tabId = sessionStorage.getItem("tabId") || Date.now().toString();
        sessionStorage.setItem("tabId", tabId);
        
        const result1 = JSON.stringify(this.multiData);
        console.log(result1,'ssdasdseasaaSrchCase...7')
        localStorage.setItem(`searchedData-multicity-${tabId}`, result1);


        // let $data = [];
        // this.multiData.itinery.forEach((v) => {
        //   console.log(v, "multy");
        //   let itineraryObject = {
        //     from: v.from.name || v.from,
        //     to: v.to.name || v.to,
        //     depdata: moment(v.departDate).format("DD-MMM-YYYY"),
        //   };
        //   $data.push(itineraryObject);
        // });
        // console.log($data, " $data $data");

        // this.multiData.itinery = $data;

        // console.log(this.multiData, "this.multiData");

        let itinerary = this.multiData.itinery
          .map((v) => {
            const from = v.from.match(/\(([^)]+)\)/)
              ? v.from.match(/\(([^)]+)\)/)[1]
              : v.from;
            const to = v.to.match(/\(([^)]+)\)/)
              ? v.to.match(/\(([^)]+)\)/)[1]
              : v.to;
            const departDate = moment(v.departDate).format("YYYY/MM/DD");
            return `${from}-${to}-${departDate}`;
          })
          .join("_");

        let tripType = "MC";
        let paxType = `A-${this.multiData.adult}_C-${this.multiData.child}_I-${this.multiData.infrant}`;
        let cabin;
        if (this.classType == "Economy") {
          cabin = "Economy";
        }
        if (this.classType == "Business") {
          cabin = "Business";
        }
        if (this.classType == "First Class") {
          cabin = "FirstClass";
        }
        if (this.classType == "Premium Economy") {
          cabin = "PremiumEconomy";
        }

        const resultData = this.handleMultiSearch(this.multiData);
        localStorage.setItem("recentFrom", JSON.stringify(resultData));

        // let muti_city = JSON.stringify(this.multiData);
        this.$router.push({
          path: "/flight/search",
          query: { itinerary, tripType, paxType, cabin },
        });
      } else {
        // alert("please enter your detail");
        // this.validateOnewayForm();
        this.validateMultiForm();
      }
    },
    validateMultiForm() {
      // let dateError = true;
      console.log("validateMultiformError");
      this.multiData.itinery.forEach((data, index) => {
        if (!data.departDate) {
          this.multiData.itinery[index].multiDateError = true;
          // dateError = false;
        } else {
          this.multiData.itinery[index].multiDateError = false;
        }
        if (!data.from) {
          this.multiData.itinery[index].multiFromError = true;
        } else {
          this.multiData.itinery[index].multiFromError = false;
        }
        if (!data.to) {
          this.multiData.itinery[index].multiToError = true;
        } else {
          this.multiData.itinery[index].multiToError = false;
        }
      });
    },

    async getPopularDestin(){
      await axios.get(this.popularDestinationApi.url , {
        headers: {
          "Content-Type": this.popularDestinationApi.type,
        },
      })
      .then((response) => {
        if(response.data){
          this.destinations = response.data
          console.log(this.destinations,'destinationsdestinations')
        }
        // else {
        //   this.topDestinations = topDestinations
        // }
      })
      .catch((err) => {
        console.log(err)
      })
    },
    async getAirlineCarousel(){
      await axios.get(this.airlineCarouselApi.url , {
        headers: {
          "Content-Type": this.airlineCarouselApi.type,
        },
      })
      .then((response) => {
        if(response.data){
          this.carousels = response.data
          console.log(this.carousels,'carouselscarouselss')
        }
        // else {
        //   this.topDestinations = topDestinations
        // }
      })
      .catch((err) => {
        console.log(err)
      })
    },
    async getWhychoose(){
      await axios.get(this.whyChooseApi.url , {
        headers: {
          "Content-Type": this.whyChooseApi.type,
        },
      })
      .then((response) => {
        if(response.data){
          this.whyChoose = response.data
        }
        // else {
        //   this.topDestinations = topDestinations
        // }
      })
      .catch((err) => {
        console.log(err)
      })
    },
    getConfig() {
      const getConfigData = getConfigDataFromLocalStorage();

      if (getConfigData) {
        let locale = this.getLangname;
        this.subscribeApi = getConfigData.payload.portal_configuration.API_endpoints.subscriber_form;
        this.autocompleteApi = getConfigData.payload.portal_configuration.API_endpoints.autocomplete;
        this.portal_domain = getConfigData.payload.portal_configuration.portal_url.replace("https://","");
        this.portal_id = getConfigData.payload.portal_configuration.portal_id;
        this.airlineApi = getConfigData.payload.portal_configuration.API_endpoints.airline_autocomplete;
        this.airportdataApi =  getConfigData.payload.portal_configuration.API_endpoints.airport_data;
        this.portalcurrency = getConfigData.payload.portal_configuration.currency.display;
        let siteContentApi = getConfigData.payload.portal_configuration.site_content_data[locale]
        if(siteContentApi){
          this.popularDestinationApi = siteContentApi.populardestination;
          this.airlineCarouselApi = siteContentApi.airlinecarousel;
          this.whyChooseApi = siteContentApi.whychoose;
          if(this.popularDestinationApi) this.getPopularDestin();
          if(this.airlineCarouselApi) this.getAirlineCarousel();
          if(this.whyChooseApi) this.getWhychoose();
        }
      }
    },
    updateContent() {
      this.getLangname = this.$i18n.locale;
      console.log(this.getLangname,'getcontententUrl...1');
      this.getConfig();
    },
  },
  created(){
    this.updateContent();
    sessionStorage.removeItem('TravelerDetails')
  },
  mounted(){
    this.recentFromData();
  }
};
</script>

<style scoped>
@import "@/assets/style.css";
.view-animate{
  opacity:1;
}
ul{
  margin-bottom:0px !important;
}
.autocompete-menual-dropdown {
  border: 1px solid lightgray;
  background-color: white;
  cursor: pointer;
  max-height: 250px;
  overflow-y: auto;
  position: absolute;
  width: 300px;
  /* max-width: 100%; */
  padding: 8px 15px;
  border-radius: 2px;
  margin-top: 18px;
  /* margin-left: -44px; */
  z-index: 99999;
  font-size: 13px;
  font-weight: 500;
  color:black;
}
.va-content {
  font-size: 13px;
  font-weight: 500;
  text-align: start;
}
.postblog-img{
    background-image: url('../assets/images/post-32.jpg') !important;
    background-size: cover;
    background-position: right center;
    background-repeat: no-repeat;
}
.swiper-onSlider{
    background-image: url('../assets/images/background-08.jpg') !important;
    background-size: cover;
    background-position: right center;
    background-repeat: no-repeat;
}
a{
  text-decoration: none;
}
ul{
  padding-left:0px;
}
label{
  margin-bottom:0px !important;
}
:deep(.v-selection-control--inline .v-label){
  font-size:18px;
  color:white;
  opacity:1;
  margin-bottom:0;
}
:deep(.v-selection-control__input > .v-icon){
  font-size:22px !important;
}
:deep(.v-radio-group .v-input__details){
  display:none;
}
:deep(.select-2 .v-field .v-field__field .v-field__input){
  height:43px;
  padding-top:0px;
  padding-bottom:10px;
}
:deep(.select-2 .v-input__control){
  background-color:white;
  height:47px;
}
:deep(.select-2 .v-field__append-inner){
  height:43px;
}
:deep(.select-2 .v-input__details){
  display:none;
}
:deep(.select-option .v-field .v-field__input){
  height:43px;
  padding-top:0px;
  padding-left:2px;
  padding-bottom:8px;
}
:deep(.select-option .v-input__control){
  background-color:white;
  color:black;
  padding:0px 12px;
  height:47px;
}
:deep(.select-option .v-field){
  padding-right:0px;
}
:deep(.select-option .v-field__append-inner){
  height:43px;
}
:deep(.roundFromTime .dp__input){
  min-height:47px;
  border-radius:0px;
  padding-left:15px;
  border:none;
}
:deep(.roundFromTime .dp__input_icon){
  display:none;
}
:deep(.roundFromTime .dp__pointer::placeholder){
  color:black;
}
:deep(.roundToTime .dp__input){
  min-height:47px;
  border-radius:0px;
  padding-left:15px;
  border:none;
}
:deep(.roundToTime .dp__input_icon){
  display:none;
}
:deep(.roundToTime .dp__pointer::placeholder){
  color:black;
}
:deep(.multiDate .dp__input){
  min-height:47px;
  border-radius:0px;
  padding-left:15px;
  border:none;
}
:deep(.multiDate .dp__input_icon){
  display:none;
}
:deep(.multiDate .dp__pointer::placeholder){
  color:black;
}
.date .disable {
  opacity: 0.3 !important;
}
.content-bottom .button-sm{
  padding:14px 19px 13px;
}
:deep(.input-styles-2 .v-input__details){
  display:none !important;
}
.content-bottom .button-sm{
  padding: 14px 10px 13px;
}
:deep(.v-field--variant-filled .v-field__overlay){
  background-color:transparent !important;
}
:deep(.v-selection-control__wrapper){
  margin-bottom:2px;
}
.thumbnail-variant-4 img{
  height: 322px;
  object-fit: cover;
}
.px-5{
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}
:deep(.v-slide-group__prev .mdi-chevron-left){
  font-size:47px;
}
:deep(.v-slide-group__next .mdi-chevron-right){
  font-size:47px;
}
:deep(.v-selection-control__input>.v-icon){
  height:26px;
}
.re-fon {
  font-size: 13px;
  font-weight: 500;
  font-family: "Barlow", sans-serif;
}
:deep(.directFlight .v-input__details){
  display:none !important;
}
@media screen and (max-width:480px) {
  .radio-inline-wrapper .checkbox-inline {
    margin-left: -11px;
    background: fixed;
  }
}
:deep(.input-styles-2 .v-field .v-field__outline){
  position:unset;
}
.content-bottom .button-sm{
  padding:14px 18px 13px;
}
:deep(.dp__calendar .dp__calendar_item .dp__cell_inner){
  width: 28px;
  height: 28px;
  font-size: 15px;
}
:deep(.dp__calendar .dp__calendar_item .dp__active_date){
  background: #bc2279 !important;
  border-radius:20px;
}
:deep(.dp__calendar .dp__calendar_item .dp__today){
  border: 1px solid #b31970;
  border-radius: 20px;
}
:deep(.input-styles-2 .v-field .v-field__outline){
  position: unset !important;
}
</style>